import { getViolationsHistoryFields } from 'KnmErknmPackage/ErknmViolationsModule/common/getViolationsHistoryFields';

import { getSubjectHistoryFields } from '../common/getSubjectHistoryFields';
import { renderAccessPrivilegeLevel } from '../common/renderAccessPrivilegeLevel';
import { renderAccessPrivilegeOrganisation } from '../common/renderAccessPrivilegeOrganisation';
import { renderAppealStatus } from '../common/renderAppealStatus';
import { renderApproveApproved } from '../common/renderApproveApproved';
import { renderApproveDocumentsDate } from '../common/renderApproveDocumentsDate';
import { renderBoolean } from '../common/renderBoolean';
import { renderDate } from '../common/renderDate';
import { renderDateWithTime } from '../common/renderDateWithTime';
import { renderIsActWasRead } from '../common/renderIsActWasRead';
import { renderMonth } from '../common/renderMonth';
import { renderPmResultDecisionSubjectType } from '../common/renderPmResultDecisionSubjectType';
import { renderPublishedStatus } from '../common/renderPublishedStatus';
import { renderRequirements } from '../common/renderRequirements';
import { renderStatusName } from '../common/renderStatusName';
import { IKnmHistoryField } from '../interfaces/IKnmHistoryField';
import { renderItAccreditationStatus } from '../common/renderItAccreditationStatus';
import { renderErvkControlKindDocTargetType } from '../common/renderErvkControlKindDocTargetType';
import { renderIsNeedApplyChangesInApprovedPlan } from '../common/renderIsNeedApplyChangesInApprovedPlan';
import { renderApprovalOfAgreement } from '../common/renderApprovalOfAgreement';
import { renderPetitionOrganizationType } from '../common/renderPetitionOrganizationType';
import { renderAgreementExecutionDecision } from '../common/renderAgreementExecutionDecision';

const systemSignatureUsedText = 'Признак использования технической подписи системы';
const systemSignatureDateTimeText = 'Дата подписания технической подписью системы';
const systemSignatureMnemonicText = 'Мнемоника системы, подписавшей технической подписью';
const systemSignatureTitleText = 'Наименование системы, подписавшей технической подписью';

export const knmHistoryFields: Record<string, IKnmHistoryField> = {
  '/id': {
    name: 'Уникальный идентификатор',
    active: false,
  },
  '/erpId': {
    name: 'Учетный номер КНМ',
    active: false,
  },
  '/planId': {
    name: 'Номер плана',
    active: true,
  },
  '/guid': {
    name: 'Уникальный идентификатор из внешней системы',
    active: false,
  },
  '/status/id': {
    name: '',
    active: false,
  },
  '/status/name': {
    name: 'Статус КНМ',
    active: true,
    renderFunc: renderStatusName,
  },
  '/status/code': {
    name: '',
    active: false,
  },
  '/status/enabled': {
    name: '',
    active: false,
  },
  '/status/weight': {
    name: '',
    active: false,
  },
  '/status/note': {
    name: 'Комментарий смены статуса',
    active: true,
  },
  '/exclusionReason/code': {
    name: '',
    active: false,
  },
  '/exclusionReason/name': {
    name: 'Причина исключения КНМ из плана',
    active: true,
  },
  '/year': {
    name: 'Год проведения КНМ',
    active: false,
  },
  '/month': {
    name: 'Месяц проведения КНМ',
    active: true,
    renderFunc: renderMonth,
  },
  '/creationDate': {
    name: 'Дата создания',
    active: false,
  },
  '/publicationDate': {
    name: 'Дата публикации',
    active: false,
  },
  '/subjectType/title': {
    name: 'Тип субъекта КНМ',
    active: true,
  },
  '/noticeDate': {
    name: 'Дата уведомления',
    active: true,
  },
  '/noticeMethod/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/type/id': {
    name: '',
    active: false,
  },
  '/type/name': {
    name: 'Характер КНМ',
    active: true,
  },
  '/type/code': {
    name: '',
    active: false,
  },
  '/type/enabled': {
    name: '',
    active: false,
  },
  '/type/weight': {
    name: '',
    active: false,
  },
  '/kind/id': {
    name: '',
    active: false,
  },
  '/kind/name': {
    name: 'Вид КНМ',
    active: true,
  },
  '/kind/code': {
    name: '',
    active: false,
  },
  '/kind/enabled': {
    name: '',
    active: false,
  },
  '/kind/weight': {
    name: '',
    active: false,
  },
  '/federalLaw/id': {
    name: '',
    active: false,
  },
  '/federalLaw/name': {
    name: 'Федеральный закон',
    active: true,
  },
  '/federalLaw/number': {
    name: 'Номер федерального закона',
    active: true,
  },
  '/title': {
    name: 'Название',
    active: true,
  },
  '/testPurchaseMethod/id': {
    name: '',
    active: false,
  },
  '/testPurchaseMethod/name': {
    name: 'Способ проведения контрольной закупки',
    active: true,
  },
  '/testPurchaseMethod/code': {
    name: '',
    active: false,
  },
  '/testPurchaseMethod/enabled': {
    name: '',
    active: false,
  },
  '/testPurchaseDescription': {
    name: 'Описание проведения контрольной закупки',
    active: true,
  },
  '/supervisionType/id': {
    name: '',
    active: false,
  },
  '/supervisionType/idBk': {
    name: '',
    active: false,
  },
  '/supervisionType/guid': {
    name: '',
    active: false,
  },
  '/supervisionType/name': {
    name: 'Вид государственного контроля (надзора)',
    active: true,
  },
  '/supervisionType/federalLaw': {
    name: '',
    active: false,
  },
  '/supervisionType/digitCode': {
    name: '',
    active: false,
  },
  '/supervisionType/code': {
    name: '',
    active: false,
  },
  '/supervisionType/enabled': {
    name: '',
    active: false,
  },
  '/startDate': {
    name: 'Дата начала проведения КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/startTime': {
    name: 'Время начала проведения КНМ',
    active: true,
  },
  '/stopDate': {
    name: 'Дата окончания КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/stopTime': {
    name: 'Время окончания КНМ',
    active: true,
  },
  '/startDateIsMonth': {
    name: 'Признак того, что дата начала КНМ это месяц',
    active: false,
  },
  '/approve': {
    name: 'Сведения о согласовании проведения КНМ с органами прокуратуры',
    active: false,
  },
  '/approve/inspectionTarget': {
    name: 'Цели, задачи, предмет КНМ',
    active: true,
  },
  '/approve/startDate': {
    name: 'Дата начала проведения КНМ',
    active: false,
    renderFunc: renderDate,
  },
  '/approve/startDateIsMonth': {
    name: 'Признак того, что дата начала КНМ это месяц',
    active: false,
  },
  '/approve/stopDate': {
    name: 'Дата окончания КНМ',
    active: false,
    renderFunc: renderDate,
  },
  '/approve/durationDays': {
    name: 'Срок проведения (дней)',
    active: true,
  },
  '/approve/durationHours': {
    name: 'Срок проведения(часов)',
    active: true,
  },
  '/approve/extDurationDays': {
    name: 'Длительность КНМ (дней)',
    active: true,
  },
  '/approve/extDurationHours': {
    name: 'Длительность КНМ (часов)',
    active: true,
  },
  '/approve/decisionPlace': {
    name: 'Место согласования',
    active: true,
  },
  '/approve/decisionDate': {
    name: 'Дата согласования',
    active: true,
  },
  '/approve/signerFullName': {
    name: 'ФИО подписанта',
    active: true,
  },
  '/approve/signerPosition': {
    name: 'Должность подписанта',
    active: true,
  },
  '/approve/approved': {
    name: 'Решение по заявлению',
    active: true,
    renderFunc: renderApproveApproved,
  },
  '/approve/isNeedApplyChangesInApprovedPlan': {
    name: 'Принять изменения в КНМ',
    active: true,
    renderFunc: renderIsNeedApplyChangesInApprovedPlan,
  },
  '/approve/documents/{id}/id': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/id': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/code': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/name': {
    name: 'Тип документа о согласовании КНМ',
    active: true,
  },
  '/approve/documents/{id}/type/atrRequired': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/dateRequired': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/atrName': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/dateName': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/approve/documents/{id}/atr': {
    name: 'Номер приказа',
    active: true,
  },
  '/approve/documents/{id}/date': {
    name: 'Дата приказа',
    active: true,
    renderFunc: renderApproveDocumentsDate,
  },
  '/approve/documents/{id}/main': {
    name: '',
    active: false,
  },
  '/approve/remarks/{id}/remark/name': {
    name: 'Замечание',
    active: true,
  },
  '/reason/null/id': {
    name: '',
    active: false,
  },
  '/reason/null/type/id': {
    name: '',
    active: false,
  },
  '/reason/null/type/name': {
    name: 'Основание проведения мероприятия',
    active: true,
  },
  '/reason/null/type/code': {
    name: '',
    active: false,
  },
  '/reason/null/type/digitCode': {
    name: '',
    active: false,
  },
  '/reason/null/type/hasText': {
    name: '',
    active: false,
  },
  '/reason/null/type/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
  },
  '/reason/null/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reason/null/type/dateRequired': {
    name: '',
    active: false,
  },
  '/reason/null/text': {
    name: 'Основание регистрации КНМ',
    active: true,
  },
  '/reason/null/date': {
    name: 'Дата основания регистрации КНМ',
    active: true,
  },
  '/reason/null/requirementDetails': {
    name: 'Реквизиты требования',
    active: true,
  },
  '/reason/null/assignmentDate': {
    name: 'Дата поручения',
    active: true,
  },
  '/reason/null/assignmentNumber': {
    name: 'Номер поручения',
    active: true,
  },
  '/reason/null/main': {
    name: '',
    active: false,
  },
  '/reason/{id}/id': {
    name: '',
    active: false,
  },
  '/reason/{id}/type/id': {
    name: '',
    active: false,
  },
  '/reason/{id}/type/code': {
    name: '',
    active: false,
  },
  '/reason/{id}/type/digitCode': {
    name: '',
    active: false,
  },
  '/reason/{id}/type/hasText': {
    name: '',
    active: false,
  },
  '/reason/{id}/order/guarantors/{id}/firstName': {
    name: 'Имя лица, издавшего поручение',
    active: true,
  },
  '/reason/{id}/order/guarantors/{id}/surname': {
    name: 'Фамилия лица, издавшего поручение',
    active: true,
  },
  '/reason/{id}/order/guarantors/{id}/middleName': {
    name: 'Отчество лица, издавшего поручение',
    active: true,
  },
  '/reason/{id}/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reason/{id}/text': {
    name: 'Основание регистрации КНМ',
    active: true,
  },
  '/reason/{id}/date': {
    name: 'Дата основания регистрации КНМ',
    active: true,
  },
  '/reason/{id}/main': {
    name: '',
    active: false,
  },
  '/reason/{id}/requirementDetails': {
    name: 'Реквизиты требования',
    active: true,
  },
  '/reason/{id}/assignmentDate': {
    name: 'Дата поручения',
    active: true,
  },
  '/reason/{id}/assignmentNumber': {
    name: 'Номер поручения',
    active: true,
  },
  '/reason/{id}/title': {
    name: 'Основание проведения мероприятия',
    active: true,
  },
  '/reason/{id}/type/name': {
    name: 'Основание проведения мероприятия',
    active: false,
  },
  '/reason/{id}/type/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reason/{id}/type/dateRequired': {
    name: '',
    active: false,
  },
  '/reason/{id}/dateRequirement': {
    name: 'Дата требования',
    active: true,
    renderFunc: renderDate,
  },
  '/reason/type/name': {
    name: 'Основание проведения КНМ',
    active: false,
  },
  '/reason/{id}/links/{id}/erpId': {
    name: 'Номер связанного паспорта',
    active: true,
  },
  '/reasons/{id}/id': {
    name: '',
    active: false,
  },
  '/reasons/{id}/type/id': {
    name: '',
    active: false,
  },
  '/reasons/{id}/knmIdLink': {
    name: 'Ссылка на другой паспорт',
    active: true,
  },
  '/reasons/{id}/type/name': {
    name: 'Основание проведения мероприятия',
    active: true,
  },
  '/reasons/{id}/type/code': {
    name: '',
    active: false,
  },
  '/reasons/{id}/type/digitCode': {
    name: '',
    active: false,
  },
  '/reasons/{id}/type/hasText': {
    name: '',
    active: false,
  },
  '/reasons/{id}/type/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/type/dateRequired': {
    name: '',
    active: false,
  },
  '/reasons/{id}/text': {
    name: 'Основание регистрации КНМ',
    active: true,
  },
  '/reasons/{id}/date': {
    name: 'Дата основания регистрации КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/reasons/{id}/main': {
    name: '',
    active: false,
  },
  '/reasons/{id}/riskCategory/title': {
    name: 'Индикаторы риска',
    active: true,
  },
  '/legalBases/{id}/atrI': {
    name: 'Раздел правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrII': {
    name: 'Глава правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrIII': {
    name: 'Статья правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrIV': {
    name: 'Пункт правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrV': {
    name: 'Часть правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrNumber': {
    name: 'Номер нормативно-правового акта правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/atrDate': {
    name: 'Дата нормативно-правового акта правового основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/documentName': {
    name: 'Правовые основания проведения КНМ',
    active: true,
  },
  '/legalBases/{id}/instruction/id': {
    name: '',
    active: false,
  },
  '/legalBases/{id}/instruction/code': {
    name: '',
    active: false,
  },
  '/legalBases/{id}/instruction/name': {
    name: '',
    active: false,
  },
  '/legalBases/{id}/instruction/enabled': {
    name: '',
    active: false,
  },
  '/legalBases/{id}/instruction/weight': {
    name: '',
    active: false,
  },
  '/legalBases/{id}/guid': {
    name: '',
    active: false,
  },
  '/events/{id}/guid': {
    name: '',
    active: false,
  },
  '/events/{id}/name': {
    name: 'Перечень мероприятий по контролю, необходимых для достижения целей и задач проведения КНМ',
    active: true,
  },
  '/events/{id}/startDate': {
    name: 'Дата начала мероприятия по контролю',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/stopDate': {
    name: 'Дата окончания мероприятия по контролю',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/event/startDate': {
    name: 'Дата начала действий, осуществляемых в рамках КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/event/stopDate': {
    name: 'Дата окончания действий, осуществляемых в рамках КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/events/{id}/event/uavTechnologies/{id}/name': {
    name: 'Название беспилотника',
    active: false,
  },
  '/events/{id}/event/uavTechnologies/{id}/typeCode': {
    name: 'Вид беспилотника',
    active: false,
  },
  '/knoOrganization/organization/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/guid': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/fullName': {
    name: 'Наименование органа контроля',
    active: true,
  },
  '/knoOrganization/organization/shortName': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/ogrn': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/ssn': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/adminLevel/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/adminLevel/title': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/adminLevel/description': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/type/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/type/title': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/type/description': {
    name: '',
    active: false,
  },
  '/knoOrganization/organization/parentId': {
    name: '',
    active: false,
  },
  '/knoOrganization/main': {
    name: '',
    active: false,
  },
  '/knoOrganization/address': {
    name: 'Адрес органа контроля',
    active: true,
  },
  '/knoOrganization/{id}/collaboratingKnoName': {
    name: 'Наименование органа контроля, с которым КНМ проводится совместно',
    active: true,
  },
  '/knoOrganization/functions/{id}/idFrgu': {
    name: '',
    active: false,
  },
  '/knoOrganization/functions/{id}/fullName': {
    name: 'Указание на реестровый номер функции ФРГУ',
    active: true,
  },
  '/knoOrganization/functions/{id}/main': {
    name: '',
    active: false,
  },
  '/knoOrganization/functions/{id}/id': {
    name:
      'Реестровый номер функции в федеральной государственной информационной системе Федеральный реестр государственных и муниципальных услуг',
    active: true,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/guid': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/fullName': {
    name:
      'Наименование функции в федеральной государственной информационной системе Федеральный реестр государственных и муниципальных услуг',
    active: true,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/shortName': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/ogrn': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/ssn': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/adminLevel/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/adminLevel/title': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/adminLevel/description': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/type/id': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/type/title': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/type/description': {
    name: '',
    active: false,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/parentId': {
    name: '',
    active: false,
  },
  '/inspector/{id}/fullName': {
    name: 'ФИО должностного лица, уполномоченного на проведение проверки',
    active: true,
  },
  '/inspector/{id}/inspectorType/name': {
    name: 'Тип лица, уполномоченного на проведение КНМ',
    active: true,
  },
  '/inspector/{id}/position': {
    name: 'Должность лица, уполномоченного на проведение КНМ',
    active: true,
  },
  '/inspectors/{id}/fullName': {
    name: 'ФИО должностного лица, уполномоченного на проведение проверки',
    active: true,
  },
  '/inspectors/{id}/position': {
    name: 'Должность лица, уполномоченного на проведение КНМ',
    active: true,
  },
  '/inspectors/{id}/type/id': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/type/name': {
    name: 'Тип лица, уполномоченного на проведение КНМ',
    active: true,
  },
  '/inspectors/{id}/type/code': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/type/weight': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/main': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/guid': {
    name: '',
    active: false,
  },
  '/inspectors/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/prosecutorOrganization': {
    name: 'Прокуратура согласования проведения КНМ',
    active: true,
  },
  '/rejectReasons/{id}/id': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/type/id': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/type/name': {
    name: 'Тип основания отказа КНМ',
    active: true,
  },
  '/rejectReasons/{id}/type/digitCode': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/type/code': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/type/hasText': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/type/dateRequired': {
    name: '',
    active: false,
  },
  '/rejectReasons/{id}/text': {
    name: 'Основание отказа КНМ',
    active: true,
  },
  '/rejectReasons/{id}/date': {
    name: 'Дата отклонения проверки',
    active: true,
  },
  '/rejectReasons/{id}/main': {
    name: '',
    active: false,
  },
  '/pmRejects/{id}/date': {
    name: 'Дата выявления причины непроведения профилактического мероприятия',
    active: true,
  },
  '/pmCanceledReason/name': {
    name: 'Причина непроведения профилактического мероприятия',
    active: true,
  },
  '/organization/inn': {
    name: 'Идентификационный номер налогоплательщика (ИНН)',
    active: true,
  },
  '/organization/ogrn': {
    name: 'Основной государственный регистрационный номер (ОГРН)',
    active: true,
  },
  '/organization/isResident': {
    name: '',
    active: false,
  },
  '/organization/organizationName': {
    name:
      'Наименование юридического лица или фамилию, имя, отчество (последнее - при наличии) индивидуального предпринимателя, в отношении которого проводится КНМ',
    active: true,
  },
  '/organization/organizationNameFns': {
    name: '',
    active: false,
  },
  '/organization/licenseReason': {
    name:
      'Постановление о назначении административного назначения или решении о приостановлении и (или) аннулировании лицензии',
    active: true,
  },
  '/organization/type/id': {
    name: '',
    active: false,
  },
  '/organization/type/name': {
    name: 'Тип субъекта КНМ',
    active: true,
  },
  '/organization/type/code': {
    name: '',
    active: false,
  },
  '/organization/type/federalLaw': {
    name: '',
    active: false,
  },
  '/organization/type/enabled': {
    name: '',
    active: false,
  },
  '/organization/type/weight': {
    name: '',
    active: false,
  },
  '/organization/registrationDate': {
    name: 'Дата регистрации',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/foundationDate': {
    name: 'Дата основания нормативно-правового акта',
    active: true,
  },
  '/organization/foundationDateFns': {
    name: '',
    active: false,
  },
  '/organization/lastInspectionDate': {
    name: 'Дата проведения последней проверки',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/licenseReasonStartDate': {
    name: 'Дата вступления в законную силу',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/licenseReasonKnmEndDate': {
    name: 'Дата окончания проведения КНМ, по результатам которого они приняты',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/status': {
    name: '',
    active: false,
  },
  '/organization/statusFns': {
    name: '',
    active: false,
  },
  '/organization/isSmallEnterprise': {
    name: '',
    active: false,
  },
  '/organization/isSmallEnterpriseFns': {
    name: 'Наличие проверяемого лица в реестре МСП',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/isLegalEntity': {
    name: '',
    active: false,
  },
  '/organization/isIndividualEntrepreneur': {
    name: '',
    active: false,
  },
  '/organization/isProjectCompany': {
    name: '',
    active: false,
  },
  '/organization/resolved': {
    name: '',
    active: false,
  },
  '/riskCategory/id': {
    name: '',
    active: false,
  },
  '/riskCategory/name': {
    name: 'Категория риска',
    active: true,
  },
  '/riskCategory/code': {
    name: '',
    active: false,
  },
  '/riskCategory/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/address': {
    name: 'Местоположение объекта проведения КНМ',
    active: true,
  },
  '/objects/{id}/manualAddress': {
    name: 'Адрес объекта проведения КНМ (нет в ФИАС)',
    active: true,
  },
  '/objects/{id}/region': {
    name: 'Субъект РФ объекта проведения КНМ (нет в ФИАС)',
    active: true,
  },
  '/objects/{id}/fiasRegion/name': {
    name: 'Субъект РФ объекта проведения КНМ (нет в ФИАС)',
    active: true,
  },
  '/objects/{id}/region/name': {
    name: 'Субъект РФ объекта проведения КНМ (нет в ФИАС)',
    active: true,
  },
  '/objects/{id}/addressType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/addressType/name': {
    name: 'Тип места проведения КНМ',
    active: true,
  },
  '/objects/{id}/addressType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/addressType/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/objectType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/objectType/name': {
    name: 'Тип объекта проведения КНМ',
    active: true,
  },
  '/objects/{id}/objectType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/isAddressHazard': {
    name: 'Является ОПО',
    active: true,
    renderFunc: renderBoolean,
  },
  '/objects/{id}/riskCategory/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/riskCategory/name': {
    name: 'Категория риска объекта проведения КНМ',
    active: true,
  },
  '/objects/{id}/riskCategory/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/riskCategory/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/actCreateDate': {
    name: 'Дата и время составления акта о проведении КНМ',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/objects/{id}/result/actAddress': {
    name: 'Место составления акта о проведении КНМ',
    active: true,
  },
  '/objects/{id}/result/actAddressType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/actAddressType/name': {
    name: 'Тип места составления акта о проведении КНМ',
    active: true,
  },
  '/objects/{id}/result/actAddressType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/actAddressType/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/startDate': {
    name: 'Дата и время проведения КНМ',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/objects/{id}/result/isAddressHazard': {
    name: 'Является ОПО',
    active: true,
    renderFunc: renderBoolean,
  },
  '/objects/{id}/result/durationDays': {
    name: 'Продолжительность проведения КНМ (Дней) по результату',
    active: true,
  },
  '/objects/{id}/result/durationHours': {
    name: 'Продолжительность проведения КНМ (Часов) по результату',
    active: true,
  },
  '/objects/{id}/result/impossibleConductionReason': {
    name: 'Сведения о причинах невозможности проведения КНМ (в случае если КНМ не проведено)',
    active: true,
  },
  '/approve/impossibleConductionReason': {
    name: 'Сведения о причинах невозможности проведения КНМ (в случае если КНМ не проведено)',
    active: true,
  },
  '/objects/{id}/result/cancellationInfo': {
    name: 'Сведения об отмене результатов КНМ (в случае если такое КНМ было произведено)',
    active: true,
  },
  '/objects/{id}/result/actWasNotRead': {
    name: 'Отказ от ознакомления',
    active: true,
    renderFunc: renderBoolean,
  },
  '/objects/{id}/result/actWasNotReadInfo': {
    name:
      'Сведения об ознакомлении или отказе ознакомления с актом КНМ руководителя, иного должностного лица или уполномоченного представителя юридического лица, индивидуального предпринимателя, его уполномоченного представителя, присутствовавших при проведении КНМ, о наличии их подписей или об отказе от совершения подписи',
    active: true,
  },
  '/objects/{id}/result/wrongNotificationData': {
    name:
      'Сведения о несоответствии информации, содержащейся в уведомлении о начале осуществления отдельных видов предпринимательской деятельности, обязательным требованиям (с указанием положений нормативных правовых актов)',
    active: true,
  },
  '/objects/{id}/result/violationLackInfo': {
    name:
      'Указание на отсутствие выявленных нарушений обязательных требований или требований, установленных муниципальными правовыми актами (в случае если нарушений обязательных требований или требований, установленных муниципальными правовыми актами, не выявлено)',
    active: true,
  },
  '/objects/{id}/result/inspectors/{id}/fullName': {
    name: 'Фамилия, имя, отчество (последнее - при наличии) должностного лица (должностных лиц), проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/inspectors/{id}/position': {
    name: 'Должность должностного лица (должностных лиц), проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/inspectors/{id}/type/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/type/name': {
    name: 'Тип должностного лица (должностных лиц), проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/inspectors/{id}/type/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/type/weight': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/inspectors/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/fullName': {
    name:
      'Фамилия, имя, отчество (последнее - при наличии) руководителя, должностного лица, уполномоченного представителя проверяемого лица присутствовавшего при проведении КНМ',
    active: true,
  },
  '/objects/{id}/result/delegates/{id}/position': {
    name:
      'Должность руководителя, должностного лица, уполномоченного представителя проверяемого лица присутствовавшего при проведении КНМ',
    active: true,
  },
  '/objects/{id}/result/delegates/{id}/type/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/type/name': {
    name:
      'Тип руководителя, должностного лица, уполномоченного представителя проверяемого лица присутствовавшего при проведении КНМ',
    active: true,
  },
  '/objects/{id}/result/delegates/{id}/type/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/delegates/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/additionalInfo/{id}/resultInfoType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/additionalInfo/{id}/resultInfoType/name': {
    name: 'Сведения о мерах, принятых по результатам КНМ',
    active: true,
  },
  '/objects/{id}/result/additionalInfo/{id}/resultInfoType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/additionalInfo/{id}/information': {
    name: 'Сведения о результатах проведения КНМ',
    active: true,
  },
  '/objects/{id}/result/additionalInfo/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/note': {
    name:
      'Сведения о выявленных нарушениях обязательных требований и требований, установленных муниципальными правовыми актами',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/act': {
    name: 'Положение нарушенного правового акта',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/type/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/type/name': {
    name: 'Характер выявленного нарушения',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/type/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/type/weight': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrI': {
    name: 'Положение нарушенного правового акта.Раздел',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrII': {
    name: 'Положение нарушенного правового акта.Глава',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrIII': {
    name: 'Положение нарушенного правового акта.Статья',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrIV': {
    name: 'Положение нарушенного правового акта.Пункт',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrV': {
    name: 'Положение нарушенного правового акта.Часть',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrNumber': {
    name: 'Номер нарушенного правового акта',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/atrDate': {
    name: 'Дата нарушенного правового акта',
    active: true,
    renderFunc: renderDate,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/documentName': {
    name: 'Положение нарушенного правового акта',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/instruction/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/instruction/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/instruction/name': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/instruction/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/instruction/weight': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/legalBases/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/text': {
    name: 'Сведения о выявленном нарушении',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/lawsuitType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/lawsuitType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/lawsuitType/digitCode': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/lawsuitType/name': {
    name: 'Тип сведений о выявленном нарушении',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/lawsuits/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/code': {
    name: 'Реквизиты предписания',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/note': {
    name: 'Содержание предписания',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/executionNote': {
    name:
      'Сведения о выполнении лицом, в отношении которого проводилась проверка, предписания об устранении выявленных нарушений',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/isRefused': {
    name: 'Отметка о невыполнении предписания об устранении выявленных нарушений в результате проведения КНМ',
    active: true,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/appointmentDate': {
    name: 'Дата вынесения предписания',
    active: true,
    renderFunc: renderDate,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/executionDeadline': {
    name: 'Срок выполнения предписания',
    active: true,
    renderFunc: renderDate,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/injunctions/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/main': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/result/violations/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/name': {
    name: 'Наименование проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/approval': {
    name: 'Сведения об утверждении проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/question': {
    name: 'Вопрос проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/legalBase': {
    name: 'Реквизиты НПА устанавливающего обязательные требования',
    active: true,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/answerType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/answerType/name': {
    name: 'Ответ на вопрос проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/answerType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/answerType/hasText': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/answer': {
    name: 'Ответ на вопрос проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/questions/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/template': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/fullnessType/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/fullnessType/name': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/fullnessType/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/fullnessType/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/fullnessType/weight': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/fullName': {
    name: 'Наименование организации проверочного листа',
    active: true,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/shortName': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/ogrn': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/ssn': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/adminlevel/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/adminlevel/title': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/adminlevel/description': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/type/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/type/title': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/type/description': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/knoOrganization/parentId': {
    name: '',
    active: false,
  },
  '/objects/{id}/checklists/{id}/ervkChecklistNumber': {
    name: 'Номер проверочного листа из ЕРВК',
    active: true,
  },
  '/objects/{id}/checklists/{id}/ervkChecklistDescription': {
    name: 'Название проверочного листа из ЕРВК',
    active: true,
  },
  '/objects/{id}/supervisions/{id}/id': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/idBk': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/name': {
    name: 'Вид (виды) контроля (надзора) объекта контроля',
    active: true,
  },
  '/objects/{id}/supervisions/{id}/title': {
    name: 'Вид (виды) контроля (надзора) объекта контроля',
    active: true,
  },
  '/objects/{id}/supervisions/{id}/federalLaw': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/digitCode': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/code': {
    name: '',
    active: false,
  },
  '/objects/{id}/supervisions/{id}/enabled': {
    name: '',
    active: false,
  },
  '/objects/{id}/guid': {
    name: '',
    active: false,
  },
  '/objects/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/subjectNotifications/{id}/noticeMethod/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/subjectNotifications/{id}/date': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/subjectNotifications/{id}/comment': {
    name: 'Примечание к уведомлению',
    active: true,
  },
  '/documents/{id}/type/id': {
    name: '',
    active: false,
  },
  '/documents/{id}/type/name': {
    name: 'Тип документа',
    active: true,
  },
  '/documents/{id}/type/code': {
    name: '',
    active: false,
  },
  '/documents/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/documents/{id}/type/weight': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/guid': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/dateCreate': {
    name: 'Дата и время загрузки файла',
    active: true,
  },
  '/documents/{id}/attachments/{id}/fileName': {
    name: 'Файл',
    active: true,
  },
  '/documents/{id}/attachments/{id}/filePath': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/fileSize': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/mimeType': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/bucketName': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/hash': {
    name: '',
    active: false,
  },
  '/documents/{id}/attachments/{id}/signed': {
    name: '',
    active: false,
  },
  '/documents/{id}/guid': {
    name: '',
    active: false,
  },
  '/documents/{id}/correlationToken': {
    name: '',
    active: false,
  },
  '/documents/{id}/description': {
    name: 'Описание документа',
    active: true,
  },
  '/links/{id}/guid': {
    name: '',
    active: false,
  },
  '/links/{id}/erpId': {
    name: 'Номер связанного КНМ',
    active: true,
  },
  '/links/{id}/type/id': {
    name: '',
    active: false,
  },
  '/links/{id}/type/name': {
    name: 'Тип связывания',
    active: true,
  },
  '/links/{id}/type/code': {
    name: '',
    active: false,
  },
  '/links/{id}/type/enabled': {
    name: '',
    active: false,
  },
  '/links/{id}/type/weight': {
    name: '',
    active: false,
  },
  '/district/id': {
    name: '',
    active: false,
  },
  '/district/name': {
    name: '',
    active: false,
  },
  '/district/center': {
    name: '',
    active: false,
  },
  '/district/okatoTer': {
    name: '',
    active: false,
  },
  '/district/okatoKod1': {
    name: '',
    active: false,
  },
  '/district/okatoRazdel': {
    name: '',
    active: false,
  },
  '/district/federalRegionCode': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/id': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/name': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/code': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/codeOld': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/weight': {
    name: '',
    active: false,
  },
  '/district/federalDistrict/enabled': {
    name: '',
    active: false,
  },
  '/requirements/{id}/name': {
    name: 'Наименование обязательного требования',
    active: true,
  },
  '/requirements/{id}/template': {
    name: '',
    active: true,
  },
  '/requirements/{id}/template/name': {
    name: 'Обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/guid': {
    name: '',
    active: false,
  },
  '/requirements/{id}/documents/{id}/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/documents/{id}/name': {
    name: 'Формулировка обязательного требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/name': {
    name: 'Формулировка обязательного требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/props': {
    name: 'Наименование НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/props': {
    name: 'Наименование НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/number': {
    name: 'Номер НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/number': {
    name: 'Номер НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/date': {
    name: 'Дата НПА, устанавливающего обязательные требования',
    active: true,
    renderFunc: renderDate,
  },
  '/requirements/{id}/requirements/{id}/date': {
    name: 'Дата НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/paragraph': {
    name: 'Пункт НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/paragraph': {
    name: 'Пункт НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/part': {
    name: 'Часть НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/part': {
    name: 'Часть НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/article': {
    name: 'Статья НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/requirements/{id}/article': {
    name: 'Статья НПА, устанавливающего обязательные требования',
    active: true,
  },
  '/requirements/{id}/documents/{id}/index': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/guid': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/fullName': {
    name: 'Контролирующий орган обязательного требования',
    active: true,
  },
  '/requirements/{id}/knoOrganization/shortName': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/ogrn': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/ssn': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/adminLevel/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/adminLevel/title': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/adminLevel/description': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/type/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/type/title': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/type/description': {
    name: '',
    active: false,
  },
  '/requirements/{id}/knoOrganization/parentId': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/idBk': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/guid': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/name': {
    name: 'Вид государственного контроля (надзора) обязательного требования',
    active: true,
  },
  '/requirements/{id}/supervisionType/federalLaw/id': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/federalLaw/name': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/digitCode': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/code': {
    name: '',
    active: false,
  },
  '/requirements/{id}/supervisionType/enabled': {
    name: '',
    active: false,
  },
  '/requirements/{id}/guid': {
    name: '',
    active: false,
  },
  '/deleted': {
    name: '',
    active: false,
  },
  '/publishedStatus': {
    name: 'Статус публикации КНМ',
    active: true,
    renderFunc: renderPublishedStatus,
  },
  '/manualPublish': {
    name: '',
    active: false,
  },
  '/published': {
    name: '',
    active: false,
  },
  '/correlationToken': {
    name: '',
    active: false,
  },
  '/createdBy/id': {
    name: '',
    active: false,
  },
  '/createdBy/username': {
    name: '',
    active: false,
  },
  '/createdBy/fullName': {
    name: '',
    active: false,
  },
  '/created': {
    name: '',
    active: false,
  },
  '/updated': {
    name: '',
    active: false,
  },
  '/updatedBy/id': {
    name: '',
    active: false,
  },
  '/updatedBy/username': {
    name: '',
    active: false,
  },
  '/updatedBy/fullName': {
    name: '',
    active: false,
  },
  '/note': {
    name: '',
    active: false,
  },
  '/hash': {
    name: '',
    active: false,
  },
  '/signed': {
    name: 'КНМ подписан электронной подписью',
    active: true,
    renderFunc: renderBoolean,
  },
  '/knoOrganization/title': {
    name: 'Наименование органа контроля',
    active: true,
  },
  '/kindControl/title': {
    name: 'Вид контроля (надзора)',
    active: true,
  },
  '/supervisionType/title': {
    name: 'Вид контроля (надзора)',
    active: true,
  },
  '/pmType/title': {
    name: 'Вид профилактического мероприятия',
    active: true,
  },
  '/pmForm/title': {
    name: 'Форма проведения профилактического мероприятия',
    active: true,
  },
  '/location': {
    name: 'Место проведения профилактического мероприятия',
    active: true,
  },
  '/manualAddress': {
    name: 'Адрес места проведения профилактического мероприятия (нет в ФИАС)',
    active: true,
  },
  '/region': {
    name: 'Субъект РФ места проведения профилактического мероприятия (нет в ФИАС)',
    active: true,
  },
  '/kindKnm/title': {
    name: 'Вид КНМ',
    active: true,
  },
  '/decision/dateTimeDecision': {
    name: 'Дата и время издания решения',
    active: true,
    renderFunc: renderDate,
  },
  '/decision/numberDecision': {
    name: 'Номер решения',
    active: true,
  },
  '/durationDays': {
    name: 'Срок проведения (дней)',
    active: true,
  },
  '/durationHours': {
    name: 'Срок проведения (часов)',
    active: true,
  },
  '/directDurationDays': {
    name: 'Срок непосредственного взаимодействия (дней)',
    active: true,
  },
  '/prosecutorOrganization/name': {
    name: 'Наименование прокуратуры',
    active: true,
  },
  '/approve/note': {
    name: 'Комментарий',
    active: true,
  },
  '/approve/numberDecision': {
    name: 'Номер решения',
    active: true,
  },
  '/approve/dateDecision': {
    name: 'Дата решения',
    active: true,
    renderFunc: renderDate,
  },
  '/approve/fioSigner': {
    name: 'Кем принято решение',
    active: true,
  },
  '/approve/titleSigner': {
    name: 'Должность лица, подписавшего решение',
    active: true,
  },
  '/approve/rejectReasonType/name': {
    name: 'Причина отказа',
    active: true,
  },
  '/approve/dateRejectReason': {
    name: 'Дата отказа',
    active: true,
  },
  '/organization/{id}/inn': {
    name: 'Идентификационный номер налогоплательщика (ИНН)',
    active: true,
  },
  '/organization/{id}/ogrn': {
    name: 'Основной государственный регистрационный номер (ОГРН)',
    active: true,
  },
  '/organization/{id}/nkoForeignAgentsRegistryNumber': {
    name: 'Регистрационный номер в реестре НКО-иноагентов',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentNote': {
    name: 'Комментарий',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/country/title': {
    name: 'Государство, в котором указанное юридическое лицо зарегистрировано',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentTerm': {
    name: 'Срок',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/structuresNPA/{id}/value': {
    name:
      'Структурные единицы нормативных правовых актов, содержащих информацию\n' +
      'о мерах ответственности контролируемых лиц',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/status': {
    name: 'Статус решения',
    active: true,
  },
  '/organization/{id}/nkoForeignAgentsRegistryInclusionDate': {
    name: 'Дата включения в реестр НКО иноагентов',
    active: true,
  },
  '/organization/{id}/nkoForeignAgentsRegistryExclusionDate': {
    name: 'Дата исключения в реестр НКО иноагентов',
    active: true,
  },
  '/organization/{id}/kpp': {
    name: 'Код причины постановки на учет (КПП)',
    active: true,
  },
  '/organization/{id}/rafpNza': {
    name: 'Номер записи об аккредитации в РАФП (НЗА)',
    active: true,
  },
  '/organization/{id}/sonko': {
    name: 'Наличие контролируемого лица в реестре СОНКО',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/wasInItRegistry': {
    name: 'Наличие в реестре аккредитованных IT-организаций',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/itAccreditationResponse/registryNumber': {
    name: 'Регистрационный номер',
    active: true,
  },
  '/organization/{id}/itAccreditationResponse/dateRecord': {
    name: 'Дата внесения записи в реестр аккредитованных IT-организаций',
    active: true,
  },
  '/organization/{id}/itAccreditationResponse/dateChange': {
    name: 'Дата внесения изменения в запись реестра аккредитованных IT-организаций',
    active: true,
  },
  '/organization/{id}/itAccreditationResponse/numberDecisionAccreditation': {
    name: 'Номер решения о государственной аккредитации ИТ-компании',
    active: true,
  },
  '/organization/{id}/itAccreditationResponse/informationAboutChanges': {
    name: 'Сведения об изменениях в реестре аккредитованных IT-организаций',
    active: true,
  },
  '/organization/{id}/itAccreditationResponse/dateDecisionAccreditation': {
    name: 'Дата решения о государственной аккредитации ИТ-компании',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/itAccreditationResponse/organizationStatus': {
    name: 'Статус организации в реестре аккредитованных ИТ-компаний',
    active: true,
    renderFunc: renderItAccreditationStatus,
  },
  '/organization/{id}/locationAddress': {
    name: 'Адрес места нахождения',
    active: true,
  },
  '/organization/{id}/workAddress': {
    name: 'Место нахождения (осуществления деятельности) контролируемого лица',
    active: true,
  },
  '/organization/{id}/factualAddress': {
    name: 'Место фактического осуществления деятельности',
    active: true,
  },
  '/organization/{id}/snils': {
    name: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
    active: true,
  },
  '/organization/{id}/document': {
    name: 'Сведения о документе, удостоверяющем личность',
    active: true,
  },
  '/organization/{id}/country': {
    name: 'Государство, в котором указанное юридическое лицо зарегистрировано',
    active: true,
  },
  '/organization/{id}/subjectType/title': {
    name: 'Тип контролируемого лица',
    active: true,
  },

  ...getSubjectHistoryFields('subject'),
  '/organization/{id}/organizationName': {
    name: 'Наименование проверяемого лица',
    active: true,
  },
  '/organization/{id}/organizationName/fio': {
    name: 'Фамилия, имя, отчество (при наличии)',
    active: true,
  },

  '/organization/{id}/number': {
    name: 'ОКВЭД',
    active: true,
  },
  '/organization/{id}/mspCode': {
    name: 'Категория субъекта МСП',
    active: true,
  },
  '/organization/{id}/okveds/{id}/name': {
    name: 'Наименование ОКВЭД',
    active: true,
  },
  '/organization/{id}/okveds/{id}/code': {
    name: 'Номер ОКВЭД',
    active: true,
  },
  '/organization/{id}/act/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/{id}/act/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/organization/{id}/act/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/objects/{id}/objectType/title': {
    name: 'Тип объекта',
    active: true,
  },
  '/objects/{id}/objectKind/title': {
    name: 'Вид объекта',
    active: true,
  },
  '/objects/{id}/objectSubKind/title': {
    name: 'Подвид объекта',
    active: true,
  },
  '/objects/{id}/riskCategory/title': {
    name: 'Категория риска',
    active: true,
  },
  '/objects/{id}/dangerClass/title': {
    name: 'Класс опасности',
    active: true,
  },
  '/objects/{id}/name': {
    name: 'Наименование объекта',
    active: true,
  },
  '/objects/{id}/ervkNumber': {
    name: 'Номер объекта',
    active: true,
  },
  '/objects/{id}/cosId': {
    name: 'Номер объекта',
    active: true,
  },
  '/objects/{id}/cosVersion': {
    name: 'Объект контроля — версия',
    active: true,
  },
  '/objects/{id}/geolocation': {
    name: 'Координаты объекта',
    active: true,
  },
  '/isHasNotification': {
    name: 'Информация об уведомлении проверяемого лица о проведении ПМ',
    active: true,
    renderFunc: renderBoolean,
  },
  '/dateOfNotification': {
    name: 'Дата уведомления проверяемого лица о проведении ПМ',
    active: true,
    renderFunc: renderDate,
  },
  '/isRejectSubject': {
    name: 'Информация о несогласии контролируемого лица на проведение мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  '/dateRejectSubject': {
    name: 'Дата информации о несогласии контролируемого лица на проведение мероприятия',
    active: true,
    renderFunc: renderDate,
  },
  '/resultOfInspection': {
    name: 'Результат профилактического мероприятия',
    active: true,
  },
  '/noteWarning': {
    name: 'Сведения о содержании предостережения',
    active: true,
  },
  '/inspectors/{id}/position/title': {
    name: 'Должность лица, участвующего в КНМ',
    active: true,
  },
  '/fullName': {
    name: 'Сведения о должностном лице, участвующего в КНМ',
    active: true,
  },
  '/experts/{id}/fullName': {
    name:
      'Сведения об экспертах, экспертных организациях, специалистах, независимых органах инспекции, саморегулируемых организациях и иных лицах, привлекаемых для проведения КНМ',
    active: true,
  },
  '/experts/{id}/position': {
    name:
      'Сведения об экспертах, экспертных организациях, специалистах, независимых органах инспекции, саморегулируемых организациях и иных лицах, привлекаемых для проведения КНМ',
    active: true,
  },
  '/isHasCollaboratingOrganization': {
    name: 'Проводится совместно',
    active: true,
    renderFunc: renderBoolean,
  },
  '/collaboratingOrganizations/{id}/title': {
    name: 'Наименование органа контроля, с которым КНМ проводится совместно',
    active: true,
  },
  '/isRemote': {
    name: 'Использование в рамках КНМ средств дистанционного взаимодействия с контролируемыми лицами',
    active: true,
    renderFunc: renderBoolean,
  },
  '/interactionCategory/name': {
    name: 'Категория взаимодействия',
    active: true,
  },
  '/noteRemote': {
    name: 'Сведения об использовании в рамках КНМ средств дистанционного взаимодействия с контролируемыми лицами',
    active: true,
  },
  '/events/{id}/event/title': {
    name: 'Перечень действий, осуществляемых в рамках КНМ',
    active: true,
  },
  '/events/{id}/event/interactionCategory/name': {
    name: 'Категория взаимодействия осуществляемого действия',
    active: true,
  },
  '/events/{id}/event/submittedDocuments/{id}/documentTitle': {
    name: 'Наименование представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/event/submittedDocuments/{id}/description': {
    name: 'Описание представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/event/submittedDocuments/{id}/requestDateTime': {
    name: 'Дата и время запроса представляемого контролируемым лицом документа',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/event/submittedDocuments/{id}/submissionDeadline': {
    name: 'Срок представления представляемого контролируемым лицом документа',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/event/submittedDocuments/{id}/status/title': {
    name: 'Статус представления представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/event/submittedDocuments/{id}/files/{id}/filName': {
    name: 'Название файла представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/event/submittedDocuments/{id}/submissionDateTime': {
    name: 'Дата и время получения документа',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/submittedDocuments/{id}/documentTitle': {
    name: 'Наименование представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/submittedDocuments/{id}/description': {
    name: 'Описание представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/submittedDocuments/{id}/requestDateTime': {
    name: 'Дата и время запроса представляемого контролируемым лицом документа',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/submittedDocuments/{id}/submissionDeadline': {
    name: 'Срок представления представляемого контролируемым лицом документа',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/submittedDocuments/{id}/status/title': {
    name: 'Статус представления представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/submittedDocuments/{id}/files/{id}/filName': {
    name: 'Название файла представляемого контролируемым лицом документа',
    active: true,
  },
  '/events/{id}/submittedDocuments/{id}/submissionDateTime': {
    name: 'Дата и время получения документа',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/interactionCategory/name': {
    name: 'Категория взаимодействия осуществляемого действия',
    active: true,
  },
  '/requirements/{id}/requirement/title': {
    name: 'Формулировка обязательного требования, подлежащего проверке',
    active: true,
  },
  '/requirements/{id}/acceptanceDate': {
    name: 'Дата НПА обязательного требования, подлежащего к проверке',
    active: true,
  },
  '/places/{id}/value': {
    name: 'Место (места) проведения контрольного (надзорного) мероприятия',
    active: true,
  },
  '/places/{id}/manualAddress': {
    name: 'Адрес места проведения контрольного (надзорного) мероприятия (нет в ФИАС)',
    active: true,
  },
  '/places/{id}/region': {
    name: 'Субъект РФ места проведения контрольного (надзорного) мероприятия (нет в ФИАС)',
    active: true,
  },
  '/approveDocs/{id}/approveDoc/title': {
    name: 'Разрешительные и иные документы',
    active: true,
  },
  '/takenMeasures/{id}/value': {
    name: 'Предложенные меры',
    active: true,
  },
  '/docTarget/{id}/ervkControlKindDocTarget/type': {
    name: 'Тип разрешительного или иного документа',
    active: true,
    renderFunc: renderErvkControlKindDocTargetType,
  },
  '/docTarget/{id}/ervkControlKindDocTarget/targetTitle': {
    name: 'Выбранный разрешительный или иной документ',
    active: true,
  },
  '/docTarget/{id}/specificRequirementAndClause': {
    name: 'Конкретное проверяемое требование и пункт в разрешительном (ином) документе',
    active: true,
  },
  '/file/fileName': {
    name: 'Загруженный файл разрешительного или иного документа',
    active: true,
  },
  '/docTarget/{id}/file': {
    name: 'Загруженный файл разрешительного или иного документа',
    active: true,
  },
  '/docTarget/{id}/file/fileName': {
    name: 'Загруженный файл разрешительного или иного документа',
    active: true,
  },
  '/videoCallInfo/{id}/link': {
    name: 'Ссылка на ВКС',
    active: true,
  },
  '/videoCallInfo/{id}/dateTime': {
    name: 'Дата и время проведения ВКС',
    active: true,
    renderFunc: renderDate,
  },
  '/videoCallInfo/{id}/instruction': {
    name: 'Инструкция для встречи',
    active: true,
  },
  '/rescheduling/{id}/newStartDate': {
    name: 'Перенос проведения мероприятия - Новая дата начала КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/rescheduling/{id}/newEndDate': {
    name: 'Перенос проведения мероприятия - Новая дата окончания КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/rescheduling/{id}/oldStartDate': {
    name: 'Перенос проведения мероприятия - Дата начала до переноса КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/rescheduling/{id}/oldEndDate': {
    name: 'Перенос проведения мероприятия - Дата окончания до переноса КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/rescheduling/{id}/newDirectDurationDays': {
    name: 'Перенос проведения мероприятия - Новый срок непосредственного взаимодействия (дней)',
    active: true,
  },
  '/rescheduling/{id}/newDurationHours': {
    name: 'Перенос проведения мероприятия - Новый срок непосредственного взаимодействия (часов)',
    active: true,
  },
  '/rescheduling/{id}/comment': {
    name: 'Перенос проведения мероприятия - Комментарий',
    active: true,
  },
  '/abrogation/reasonId': {
    name: 'Сведения об отмене мероприятия - Основание для отмены',
    active: true,
  },
  '/abrogation/comment': {
    name: 'Сведения об отмене мероприятия - Комментарий',
    active: true,
  },
  '/reasonFile/fileName': {
    name: 'Сведения об отмене мероприятия - Файл основания для отмены',
    active: true,
  },
  '/abrogation/link': {
    name: 'Сведения об отмене мероприятия - Ссылка на профилактический визит',
    active: true,
  },
  '/organizationDocuments/{id}/value': {
    name: 'Перечень представляемых контролируемыми лицами документов',
    active: true,
  },
  '/organizationDocuments/{id}/isViolationResolved': {
    name: 'Факт устранения выявленного нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/numberAct': {
    name: 'Номер акта КНМ',
    active: true,
  },
  '/organization/{id}/act/creationActDateTime': {
    name: 'Дата и время составления акта КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/signActDateTime': {
    name: 'Дата и время подписания акта КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/holdingDateTime': {
    name: 'Дата и время начала проведения КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/durationDays': {
    name: 'Срок проведения (дней)',
    active: true,
  },
  '/organization/{id}/act/durationHours': {
    name: 'Срок проведения (часов)',
    active: true,
  },
  '/organization/{id}/act/fioSigner': {
    name: 'ФИО подписавшего акт',
    active: true,
  },
  '/organization/{id}/act/isViolationResolvedNote': {
    name: 'Комментарий факта устранения выявленного нарушения',
    active: true,
  },
  '/organization/{id}/act/isActWasRead': {
    name: 'Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия',
    active: true,
    renderFunc: renderIsActWasRead,
  },
  '/organization/{id}/act/acquaintanceLack': {
    name: 'Сведения о причинах не ознакомления',
    active: true,
  },
  '/organization/{id}/act/acquaintanceLackNoInfoComment': {
    name: 'Комментарий у причины неознакомления',
    active: true,
  },
  '/organization/{id}/act/fioReader': {
    name: 'Лицо, ознакомленное с результатами контрольного (надзорного) мероприятия',
    active: true,
  },
  '/organization/{id}/act/refuserFio': {
    name: 'Кто отказал',
    active: true,
  },
  '/organization/{id}/act/refuserTitle': {
    name: 'Кто отказал (должность)',
    active: true,
  },
  '/organization/{id}/act/titleReader': {
    name: 'Должность лица, ознакомленного с результатами контрольного (надзорного) мероприятия',
    active: true,
  },
  '/organization/{id}/act/noteInvalidate': {
    name: 'Сведения о признании недействительными результатов КНМ',
    active: true,
  },
  '/organization/{id}/act/remarks/{id}/remark/text': {
    name: 'Текст замечания',
    active: true,
  },
  '/organization/{id}/act/remarks/{id}/remark/signerFullName': {
    name: 'ФИО лица, оставившего замечание',
    active: true,
  },
  '/organization/{id}/act/remarks/{id}/remark/signerPosition': {
    name: 'Должность лица, оставившего замечание',
    active: true,
  },
  '/organization/{id}/act/remarks/{id}/remark/date': {
    name: 'Дата замечания',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/document/attachments/{id}/fileName': {
    name: 'Файл акта',
    active: true,
  },
  '/organization/{id}/act/titleSigner/title': {
    name: 'Должность/доверенность лица, подписавшего акт',
    active: true,
  },
  '/organization/{id}/act/typeAct/name': {
    name: 'Вид акта',
    active: true,
  },
  '/organization/{id}/act/canceledReason/name': {
    name: 'Причина невозможности проведения КНМ',
    active: true,
  },
  '/organization/{id}/act/canceledReasonDescription': {
    name: 'Описание причины невозможности проведения',
    active: true,
  },
  '/organization/{id}/act/isViolations': {
    name: 'Наличие нарушенного обязательного требования',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/involvedExperts/{id}': {
    name: 'Привлеченные эксперты',
    active: true,
  },
  '/organization/{id}/act/involvedWitnesses/{id}': {
    name: 'Привлеченные к проверке свидетели',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/document/attachments/{id}/fileName': {
    name: 'Файл решения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/kindDecision/name': {
    name: 'Вид решения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/actNumber': {
    name: 'Решение - Номер Акта',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/dateDecision': {
    name: 'Дата решения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/resultDecisions/{id}/numberDecision': {
    name: 'Номер решения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/fioSigner': {
    name: 'ФИО подписавшего решение',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/titleSigner/title': {
    name: 'Должность лица, подписавшего решение',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/inspectors/{id}/fullName': {
    name: 'ФИО лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/inspectors/{id}/position/title': {
    name: 'Должность лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/isProsecution': {
    name: 'Сведения о привлечении к ответственности по результатам контрольных (надзорных) мероприятий',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/subjectType/title': {
    name: 'Тип лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/subjectType/name': {
    name: 'Тип лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/locationAddress': {
    name: 'Адрес места нахождения лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/workAddress': {
    name: 'Место нахождения (осуществления деятельности) лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/factualAddress': {
    name: 'Место фактического осуществления деятельности лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentUins': {
    name: 'УИН',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/responsibilityType/name': {
    name: 'Сведения о виде назначенного наказания',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/type/name': {
    name: 'Тип лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/punishmentAmount': {
    name: 'Сумма размера наказаний',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/punishmentAmountMeasure': {
    name: 'Единица измерений размера наказаний',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/rafpNza': {
    name: 'Номер записи об аккредитации в РАФП лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/kpp': {
    name: 'Код причины постановки на учет (КПП) лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/document': {
    name: 'Сведения о документе, удостоверяющем личность лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/organizationName': {
    name: 'Наименование лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/ogrn': {
    name: 'ОГРН лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/inn': {
    name: 'ИНН лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/snils': {
    name: 'Снилс лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/null/position': {
    name: 'Должность лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/responsibilityType/name': {
    name: 'Сведения о виде назначенного наказания',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/type/name': {
    name: 'Тип лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentAmount': {
    name: 'Сумма размера наказаний',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentAmountMeasure': {
    name: 'Единица измерений размера наказаний',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/rafpNza': {
    name: 'Номер записи об аккредитации в РАФП лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/kpp': {
    name: 'Код причины постановки на учет (КПП) лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/organizationName': {
    name: 'Наименование лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/ogrn': {
    name: 'ОГРН лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/links/{id}/erpId': {
    name: 'Ссылка на другой паспорт КНМ или ПМ',
    active: true,
  },
  '/judgments/{id}/dateJudgment': {
    name: 'Дата судебного решения',
    active: true,
  },
  '/judgments/{id}/numberJudgment': {
    name: 'Номер судебного решения',
    active: true,
  },
  '/judgments/{id}/judgmentAction': {
    name: 'Действие судебного решения',
    active: true,
  },
  '/judgments/{id}/kindJudgment/name': {
    name: 'Вид судебного решения',
    active: true,
  },
  '/judgments/{id}/attachment/{id}/fileName': {
    name: 'Файл судебного решения',
    active: true,
  },
  '/judgments/{id}/court/rfRegion': {
    name: 'Субъект Российской Федерации',
    active: true,
  },
  '/judgments/{id}/court/title': {
    name: 'Наименование суда',
    active: true,
  },
  '/judgments/{id}/court/courtType': {
    name: 'Уровень суда',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationActsAndDecisions/{id}/cancellationInformation/name': {
    name: 'Сведения о решениях в рамках решения, которые отменены или изменены',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationActsAndDecisions/{id}/explanation': {
    name: 'Сведения о решениях в рамках решения, которые отменены или изменены - Пояснение',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/amountOfPunishment': {
    name: 'Размер наказания контролируемого лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/prosecutionType/name': {
    name: 'Вид ответственности контролируемого лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/punishmentType/name': {
    name: 'Вид наказания контролируемого лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/punishmentIndex/name': {
    name: 'Показатель наказания контролируемого лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/explanation': {
    name: 'Дополнительная информация о наказании контролируемого лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/officialPersonFio': {
    name: 'ФИО должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/officialPersonJobTitle': {
    name: 'Должность должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/amountOfPunishment': {
    name: 'Размер наказания должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/prosecutionType/name': {
    name: 'Вид ответственности должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/punishmentType/name': {
    name: 'Вид наказания должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/punishmentIndex/name': {
    name: 'Показатель наказания должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/explanation': {
    name: 'Дополнительная информация о наказании должностного лица',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/cancellationInformation/name': {
    name: 'Виды информации об отмене Акта КНМ',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/explanation': {
    name: 'Пояснение об отмене Акта КНМ',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/cancellationInformation/name': {
    name: 'Виды информации об отмене Решения КНМ',
    active: true,
  },
  '/judgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/explanation': {
    name: 'Пояснение об отмене Решения КНМ',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/cancellationInformation/name': {
    name: 'Виды информации об отмене Судебного решения для контролируемого лица',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/explanation': {
    name: 'Пояснение об отмене Судебного решения для контролируемого лица',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/cancellationInformation/name': {
    name: 'Виды информации об отмене Судебного решения для должностного лица',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/explanation': {
    name: 'Пояснение об отмене Судебного решения для должностного лица',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/newCancellationInformation/name': {
    name: 'Виды информации об отмене Судебного решения для Акта КНМ',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/newExplanation': {
    name: 'Пояснение об отмене Судебного решения для Акта КНМ',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/newCancellationInformation/name': {
    name: 'Виды информации об отмене Судебного решения для Решения КНМ',
    active: true,
  },
  '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/newExplanation': {
    name: 'Пояснение об отмене Судебного решения для Решения КНМ',
    active: true,
  },
  '/structuresNPA/{id}/value': {
    name:
      'Структурные единицы нормативных правовых актов, содержащих информацию о мерах ответственности контролируемых лиц',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/inn': {
    name: 'ИНН лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/snils': {
    name: 'Снилс лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/document': {
    name: 'Сведения о документе, удостоверяющем личность лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/position': {
    name: 'Должность лица, привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Содержание выявленного нарушенного обязательного требования',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/description': {
    name: 'Описание нарушения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolvedNote': {
    name: 'Сведения о факте устранения выявленного нарушения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/status': {
    name: 'Статус нарушения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/plannedEliminationDates/{id}/value': {
    name: 'Плановая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/descriptions/{id}/value': {
    name: 'Пояснение инспектора к устранению нарушения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/plannedMethod/{id}/title': {
    name: 'Планируемый способ устранения нарушения',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/category/name': {
    name: 'Значимость последствий нарушения содержания обязательного требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/organization/{id}/resultDecisions/{id}/noteLawsuits/{id}/value': {
    name: 'Описание решения',
    active: true,
  },
  '/withVideo': {
    name: 'Отметка об использовании видеозаписи',
    active: true,
    renderFunc: renderBoolean,
  },
  '/isPresence': {
    name: 'Отметка о присутствии контролируемого лица и (или) его представителя',
    active: true,
    renderFunc: renderBoolean,
  },
  '/isPresenceDelegateFullNames/{id}/value': {
    name: 'Отметка о присутствии контролируемого лица и (или) его представителя',
    active: true,
  },
  '/isSelection': {
    name: 'Сведения об отборе проб (образцов) продукции (товаров)',
    active: true,
    renderFunc: renderBoolean,
  },
  '/returnSelection': {
    name: 'Отметка о возврате товара',
    active: true,
    renderFunc: renderBoolean,
  },
  '/serviceDocument/description': {
    name: 'Информация о результате экспертизы продукции (товаров), результатов выполненных работ, оказанных услуг',
    active: true,
  },
  '/serviceDocument/attachments/{id}/fileName': {
    name:
      'Файл с информацией о результате экспертизы продукции (товаров), результатов выполненных работ, оказанных услуг',
    active: true,
  },
  '/objects/{id}/checklists/{id}/template/approvalDetails': {
    name: 'Объект проведения КНМ',
    active: true,
  },
  '/rejectReasons/null/rejectReasonType/name': {
    name: 'Основание отказа',
    active: true,
  },
  '/knoOrganization/collaboratingKnoName': {
    name:
      'Наименование органа контроля (надзора), органа муниципального контроля, с которым КНМ проводится совместно (в соответствии с шаблоном плана)',
    active: true,
  },
  '/knoOrganization/collaboratingOrganizations/{id}/organization/fullName': {
    name:
      'Наименование органа контроля (надзора), органа муниципального контроля, с которым КНМ проводится совместно (в соответствии со справочником ФРГУ)',
    active: true,
  },
  '/objects/{id}/result/addressType/name': {
    name: 'Тип места',
    active: true,
  },
  '/objects/{id}/result/inspector/{id}/fullName': {
    name: 'ФИО, проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/inspector/{id}/position': {
    name: 'Должность лица, проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/inspector/{id}/inspectorType/name': {
    name: 'Тип лица, проводившего КНМ',
    active: true,
  },
  '/objects/{id}/result/delegates/{id}/delegateType/name': {
    name:
      'Тип лица, уполномоченного представителя юридического лица, уполномоченного представителя индивидуального предпринимателя, присутствовавших при проведении КНМ',
    active: true,
  },
  '/reasonDocuments/{id}/type/name': {
    name: 'Тип документа в основании проведения',
    active: true,
  },
  '/reasonDocuments/{id}/attachments/{id}/fileName': {
    name: 'Файл в основании проведения',
    active: true,
  },
  '/reasonDocuments/{id}/videoFixations/{id}/linkVideo': {
    name: 'Ссылка на видеозапись или фотоматериалы',
    active: true,
  },
  '/reasonDocuments/{id}/videoFixations/{id}/dateVideo': {
    name: 'Дата фиксации',
    active: true,
    renderFunc: renderDate,
  },
  '/reasonDocuments/{id}/videoFixations/{id}/descVideo': {
    name: 'Фиксация потенциального нарушения',
    active: true,
  },
  '/approve/rejectReasonNote': {
    name: 'Мотивировка отказа',
    active: true,
  },
  '/approve/noteAppeal': {
    name: 'Решение обжаловано',
    active: true,
  },
  '/experts/{id}/type/name': {
    name: 'Тип лица, привлекаемого для проведения КНМ',
    active: true,
  },
  '/requirements/{id}/requirement/nameNpa': {
    name: 'Наименование НПА обязательного требования, подлежащего к проверке',
    active: true,
  },
  '/requirements/{id}/requirement/numberNpa': {
    name: 'Дата НПА обязательного требования, подлежащего к проверке',
    active: true,
    renderFunc: renderDate,
  },
  '/requirements/{id}/isObserved': {
    name: 'Соблюдение обязательного требования, подлежащего к проверке',
    active: true,
    renderFunc: renderBoolean,
  },
  '/requirements/{id}/note': {
    name: 'Комментарий к несоблюдению обязательного требования, подлежащего к проверке',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/injunction/dateResolved': {
    name: 'Срок исполнения решения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/resultDecisions/{id}/injunction/note': {
    name:
      'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/fullName': {
    name: 'ФИО лица привлеченного к ответственности',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/protocol/attachments/{id}/fileName': {
    name: 'Файл протокола',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/knmNoticeType/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/organization/{id}/resultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/noticeDate': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/resultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/note': {
    name: 'Примечание к уведомлению',
    active: true,
  },
  '/selection': {
    name: 'Сведения об отборе проб (образцов) продукции (товаров)',
    active: true,
  },
  '/decision/placeDecision': {
    name: 'Место вынесения решения',
    active: true,
  },
  '/decision/fioSigner': {
    name: 'ФИО должностного лица',
    active: true,
  },
  '/decision/titleSigner/title': {
    name: 'Должность лица, подписавшего решение',
    active: true,
  },
  '/decision/manualAddress': {
    name: 'Адрес места вынесения решения (нет в ФИАС)',
    active: true,
  },
  '/decision/region': {
    name: 'Субъект РФ места вынесения решения (нет в ФИАС)',
    active: true,
  },
  '/decision/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/decision/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/decision/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/decision/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/approve/approveRequired': {
    name: 'Необходимость согласования',
    active: true,
  },
  '/checklists/{id}/checkList/title': {
    name: 'Наименование проверочного листа',
    active: true,
  },
  '/checklists/{id}/ervkCheckList/number': {
    name: 'Номер из ЕРВК',
    active: true,
  },
  '/checklists/{id}/ervkCheckList/description': {
    name: 'Название из ЕРВК',
    active: true,
  },
  '/documentRequestDate': {
    name:
      'Дата направления требования представить необходимые для рассмотрения в ходе документарной проверки документы',
    active: true,
    renderFunc: renderDate,
  },
  '/documentResponseDate': {
    name:
      'Дата получения документов во исполнение требования представить необходимые для рассмотрения в ходе документарной проверки документы',
    active: true,
    renderFunc: renderDate,
  },
  '/isChecklistsUsed': {
    name: 'Отметка об использовании проверочного листа',
    active: true,
    renderFunc: renderBoolean,
  },
  '/checklists/{id}/checkList/questions/{id}/title': {
    name: 'Наименование контрольных вопросов',
    active: true,
  },
  '/checklists/{id}/answers/{id}/answerType/name': {
    name: 'Отметка выполнения',
    active: true,
  },
  '/contentWarning/attachments/{id}/fileName': {
    name: 'Содержание предостережения',
    active: true,
  },
  '/objectionWarning/attachments/{id}/fileName': {
    name: 'Сведения о направлении возражения на предостережение',
    active: true,
  },
  '/completed336': {
    name: 'Завершено по постановлению №336',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/reason/title': {
    name: 'Наименование основания',
    active: true,
  },
  '/reasons/{id}/reason/text': {
    name: 'Текст основания проведения КНМ',
    active: true,
  },
  '/reasons/{id}/reason/programNumber': {
    name: 'Номер программы проверок',
    active: true,
  },
  '/reasons/{id}/reason/prescriptionDate': {
    name: 'Дата документа',
    active: true,
  },
  '/reasons/{id}/reason/prescriptionNumber': {
    name: 'Номер документа',
    active: true,
  },
  '/reasons/{id}/reason/programAttachment/{id}/fileName': {
    name: 'Файл программы проверок',
    active: true,
  },
  '/reasons/{id}/reason/prosecutorAttachment/{id}/fileName': {
    name: 'Файл, содержащий требование прокурора',
    active: true,
  },
  '/reasons/{id}/reason/dateRequirement': {
    name: 'Дата требования',
    active: true,
    renderFunc: renderDate,
  },
  '/reasons/{id}/reason/riskCategory': {
    name: 'Индикаторы риска',
    active: false,
  },
  '/reasons/{id}/reason/passportLinks/{id}/erpId': {
    name: 'Ссылка на паспорт Решения',
    active: true,
  },
  '/reasons/{id}/reason/videoFixations/{id}/linkVideo': {
    name: 'Ссылка на видеозапись или фотоматериалы',
    active: true,
  },
  '/reasons/{id}/indicatorRiskAuto': {
    name: 'Индикатор срабатывает в автоматическом режиме',
    active: false,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/indicatorRiskAttachment/{id}/fileName': {
    name: 'Файл индикатора риска',
    active: false,
  },
  '/reasons/{id}/riskIndicators/{id}/riskIndicator/title': {
    name: 'Индикатор риска',
    active: true,
  },
  '/reasons/{id}/riskIndicators/{id}/riskIndicator/shortTitle': {
    name: 'Индикатор риска',
    active: true,
  },
  '/reasons/{id}/riskIndicators/{id}/indicatorRiskAuto': {
    name: 'Индикатор срабатывает в автоматическом режиме',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/riskIndicators/{id}/indicatorRiskAttachment/{id}/fileName': {
    name: 'Файл индикатора риска',
    active: true,
  },
  '/reasons/{id}/reason/date': {
    name: 'Дата основания проведения КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/reasons/{id}/reason/requirementDetails': {
    name: 'Реквизиты требования',
    active: true,
  },
  '/reasons/{id}/reason/assignmentDate': {
    name: 'Дата поручения',
    active: true,
    renderFunc: renderDate,
  },
  '/reasons/{id}/reason/assignmentNumber': {
    name: 'Номер поручения',
    active: true,
  },
  '/reasons/{id}/reason/approveRequired': {
    name: 'Требуется согласование с органом прокуратуры',
    active: true,
    renderFunc: renderBoolean,
  },
  '/reasons/{id}/reason/ervkUuid': {
    name: 'Идентификатор основания проведения КНМ из справочника ЕРВК',
    active: false,
  },
  '/reasons/{id}/reason/links/{id}/erpId': {
    name: 'Номер связанного паспорта',
    active: true,
  },
  '/reasons/{id}/reason/lastConductedKnmDate': {
    name: 'Основание - Дата',
    active: true,
    renderFunc: renderDate,
  },
  '/reasons/{id}/programNumber': {
    name: 'Номер программы проверок',
    active: true,
  },
  '/reasons/{id}/programAttachment/{id}/fileName': {
    name: 'Файл программы проверок',
    active: true,
  },
  '/reasons/{id}/order/guarantors/{id}/firstName': {
    name: 'Имя лица, издавшего поручение',
    active: true,
  },
  '/reasons/{id}/order/guarantors/{id}/surname': {
    name: 'Фамилия лица, издавшего поручение',
    active: true,
  },
  '/reasons/{id}/order/guarantors/{id}/middleName': {
    name: 'Отчество лица, издавшего поручение',
    active: true,
  },
  '/requirements/{id}/requirement/dateNpa': {
    name: 'Дата НПА',
    active: true,
    renderFunc: renderDate,
  },
  '/oldPlanNumber': {
    name: 'Номер плана 294-ФЗ',
    active: true,
  },
  '/oldKnmNumber': {
    name: 'Номер проверки 294-ФЗ',
    active: true,
  },
  '/checklists/{id}/answers/{id}/noteAnswer': {
    name: 'Сведение контрольного вопроса',
    active: true,
  },
  '/appealStatus': {
    name: 'Сведения об обжаловании решений и действий по результатам КНМ',
    active: true,
    renderFunc: renderAppealStatus,
  },
  '/requirements/{id}/title': {
    name: 'НПА, содержащий обязательное требование',
    active: true,
    renderFunc: renderRequirements,
  },
  '/requirements/{id}/structuralUnit/title': {
    name: 'Структурная единица',
    active: true,
    renderFunc: renderRequirements,
  },
  '/requirements/{id}/structuralUnit/mandatoryRequirements/{id}/title': {
    name: 'Содержание требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/mandatoryRequirements/{id}/title': {
    name: 'Содержание требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/organization/{id}/act/violations/{id}/title': {
    name: 'НПА нарушенного обязательного требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/title': {
    name: 'Структурная единица нарушенного обязательного требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Содержание нарушенного обязательного требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/category/name': {
    name: 'Значимость последствий нарушения содержания обязательного требования',
    active: true,
    renderFunc: renderRequirements,
  },
  '/events/{id}/event/suspension/{id}/attachments/{id}/fileName': {
    name: 'Файл решения о приостановления срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/suspension/{id}/decisionDateTime': {
    name: 'Дата и время издания решения о приостановления срока проведения КНМ',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/event/suspension/{id}/decisionNumber': {
    name: 'Номер решения о приостановления срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/suspension/{id}/decisionPlace': {
    name: 'Место вынесения решения о приостановления срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/suspension/{id}/startDate': {
    name: 'Дата начала приостановления срока проведения КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/event/suspension/{id}/stopDate': {
    name: 'Дата окончания приостановления срока проведения КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/events/{id}/event/suspension/{id}/isWorkDaysOnly': {
    name: 'При перерасчёте даты окончания КНМ и действия учитывать только рабочие дни',
    active: true,
    renderFunc: renderBoolean,
  },
  '/events/{id}/event/suspension/{id}/eventTitle': {
    name: 'Действие приостановления срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/periodExtension/attachment/fileName': {
    name: 'Файл решения о продлении срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/periodExtension/decisionDateTime': {
    name: 'Дата и время издания решения о продлении срока проведения КНМ',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/events/{id}/event/periodExtension/decisionNumber': {
    name: 'Номер решения о продлении срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/periodExtension/amountDays': {
    name: 'Продление срока проведения КНМ',
    active: true,
  },
  '/events/{id}/event/periodExtension/isWorkDaysOnly': {
    name: 'При перерасчёте даты окончания КНМ и действия учитывать только рабочие дни',
    active: true,
    renderFunc: renderBoolean,
  },
  '/accessPrivilege/{id}/organization/title': {
    name: 'Контрольный (надзорный) орган',
    active: true,
    renderFunc: renderAccessPrivilegeOrganisation,
  },
  '/accessPrivilege/{id}/accessLevel/name': {
    name: 'Уровень доступа контрольного (надзорного) органа',
    active: true,
    renderFunc: renderAccessPrivilegeLevel,
  },
  '/takenMeasures/{id}/takenMeasure/value': {
    name: 'Предложенные меры',
    active: true,
    renderFunc: renderAccessPrivilegeLevel,
  },
  '/organization/{id}/act/events/{id}/event/title': {
    name: 'Акт - Перечень действий, осуществляемых в рамках КНМ',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/inspectors/{id}/fullName': {
    name: 'Акт - Должностное лицо, осуществившее действие',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/actionNotPerformed': {
    name: 'Акт - Действие не проводилось',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/events/{id}/event/linkVks': {
    name: 'Акт - Действие - Ссылка на ВКС',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/linkVideo': {
    name: 'Акт - Действие - Ссылка на видеозапись',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/protocol/file/attachments/{id}/fileName': {
    name: 'Акт - Действие - Фаил протокола',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/protocol/appendicesToTheProtocolOfAction/{id}/attachments/{id}/fileName': {
    name: 'Акт - Действие - Приложения к протоколу действия - Фаил',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/protocol/appendicesToTheProtocolOfAction/{id}/description': {
    name: 'Акт - Действие - Приложения к протоколу действия - Описание',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/protocol/studiedDocuments/{id}/files/{id}/fileName': {
    name: 'Акт - Действие - Изученные документы - Фаил',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/protocol/studiedDocuments/{id}/description': {
    name: 'Акт - Действие - Изученные документы - Описание',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/uavTechnologies/{id}/typeCode': {
    name: 'Акт - Действие - Вид беспилотника',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/uavTechnologies/{id}/name': {
    name: 'Акт - Действие - Название беспилотника',
    active: true,
  },
  '/organization/{id}/act/events/{id}/event/startDate': {
    name: 'Акт - Дата начала действий, осуществляемых в рамках КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/events/{id}/event/stopDate': {
    name: 'Акт - Дата окончания действий, осуществляемых в рамках КНМ',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/{id}/act/knoInspectors/{id}/position/title': {
    name: 'Должностные лица контрольного (надзорного) органа, участвовавшие в контрольном (надзорном) мероприятии',
    active: true,
  },
  '/organization/{id}/act/involvedExperts/{id}/fullName': {
    name: 'Привлеченные эксперты - ФИО',
    active: true,
  },
  '/organization/{id}/act/involvedExperts/{id}/type/name': {
    name: 'Привлеченные эксперты - Должность',
    active: true,
  },
  '/organization/{id}/act/involvedWitnesses/{id}/fullName': {
    name: 'Привлеченные к проверке свидетели',
    active: true,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/appealed': {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolved': {
    name: 'Факт устранения выявленного нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolvedNote': {
    name: 'Сведения о факте устранения выявленного нарушения',
    active: true,
  },
  '/signerPosition': {
    name: 'Должность лица, подписавшего паспорт ПМ',
    active: true,
  },
  '/signerPosition/title': {
    name: 'Должность лица, подписавшего паспорт ПМ',
    active: true,
  },
  '/withoutIssue': {
    name: 'Завершение без предписания',
    active: true,
    renderFunc: renderBoolean,
  },
  '/pmResultDecisions/{id}/number': {
    name: 'Номер решения КНО',
    active: true,
  },
  '/pmResultDecisions/{id}/date': {
    name: 'Дата издания решения',
    active: true,
    renderFunc: renderDate,
  },
  '/pmResultDecisions/{id}/fileName': {
    name: 'Документ решения',
    active: true,
  },
  '/pmResultDecisions/{id}/kindDecision/name': {
    name: 'Вид решения',
    active: true,
  },
  '/pmResultDecisions/{id}/deadline': {
    name: 'Срок исполнения решения',
    active: true,
    renderFunc: renderDate,
  },
  '/pmResultDecisions/{id}/information': {
    name:
      'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
    active: true,
  },
  '/pmResultDecisions/{id}/fioSigner': {
    name: 'ФИО должностного лица',
    active: true,
  },
  '/pmResultDecisions/{id}/titleSigner/title': {
    name: 'Должность',
    active: true,
  },
  '/pmResultDecisions/{id}/subjectType': {
    name: 'Лицо, в отношении которого принято решение',
    active: true,
    renderFunc: renderPmResultDecisionSubjectType,
  },
  '/pmResultDecisions/{id}/status': {
    name: 'Статус решения',
    active: true,
  },
  ...getSubjectHistoryFields('pmResultDecisions/{id}/founder'),
  '/pmResultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/knmNoticeType/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/pmResultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/noticeDate': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/pmResultDecisions/{id}/familiarizationNotifications/{id}/familiarizationNotification/note': {
    name: 'Примечание к уведомлению',
    active: true,
  },

  '/pmResultDecision/{id}/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/pmResultDecision/{id}/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/pmResultDecision/{id}/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/pmResultDecision/{id}/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },

  // Decision
  '/organization/snils': {
    name: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
    active: true,
  },
  '/organization/originalName': {
    name: 'Наименование проверяемого лица',
    active: true,
  },
  '/organization/organizationType/title': {
    name: 'Тип лица',
    active: true,
  },
  '/organization/isSonko': {
    name: 'Наличие контролируемого лица в реестре СОНКО',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/nkoForeignAgentsRegistryNumber': {
    name: 'Регистрационный номер в реестре НКО-иноагентов',
    active: true,
  },
  '/organization/nkoForeignAgentsRegistryInclusionDate': {
    name: 'Дата включения в реестр НКО иноагентов',
    active: true,
  },
  '/organization/nkoForeignAgentsRegistryExclusionDate': {
    name: 'Дата исключения в реестр НКО иноагентов',
    active: true,
  },
  '/organization/locationAddress': {
    name: 'Адрес места нахождения',
    active: true,
  },
  '/organization/workAddress': {
    name: 'Место нахождения (осуществления деятельности) контролируемого лица',
    active: true,
  },
  '/organization/factualAddress': {
    name: 'Место фактического осуществления деятельности',
    active: true,
  },
  '/organization/document': {
    name: 'Сведения о документе, удостоверяющем личность',
    active: true,
  },
  '/organization/mspCode': {
    name: 'Категория субъекта МСП',
    active: true,
  },
  '/organization/country': {
    name: 'Государство',
    active: true,
  },
  '/organization/country/title': {
    name: 'Гражданство',
    active: true,
  },
  '/organization/isPresentInItRegistry': {
    name: 'Наличие в реестре аккредитованных IT-организаций',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/kpp': {
    name: 'Код причины постановки на учет (КПП)',
    active: true,
  },
  '/organization/rafpNza': {
    name: 'Номер записи об аккредитации в РАФП (НЗА)',
    active: true,
  },

  '/basisDocument/dateTime': {
    name: 'Дата документа',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/basisDocument/number': {
    name: 'Номер документа',
    active: true,
  },
  '/objects/null/address': {
    name: 'Адрес объекта',
    active: true,
  },
  '/objects/null/objectKind/title': {
    name: 'Вид объекта',
    active: true,
  },
  '/objects/null/objectSubKind/title': {
    name: 'Подвид объекта',
    active: true,
  },
  '/objects/null/riskCategory/title': {
    name: 'Категория риска',
    active: true,
  },
  '/objects/null/dangerClass/title': {
    name: 'Класс опасности',
    active: true,
  },
  '/objects/null/name': {
    name: 'Наименование объекта',
    active: true,
  },
  '/objects/null/ervkNumber': {
    name: 'Номер объекта',
    active: true,
  },
  '/objects/null/cosId': {
    name: 'Номер объекта',
    active: true,
  },
  '/objects/null/cosVersion': {
    name: 'Объект контроля — версия',
    active: true,
  },
  '/organization/decisions/{id}/status': {
    name: 'Статус решения',
    active: true,
  },
  '/organization/decisions/{id}/document/attachments/{id}/dateCreate': {
    name: 'Дата и время загрузки файла',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/decisions/{id}/document/attachments/{id}/fileName': {
    name: 'Файл',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/status': {
    name: 'Статус нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/description': {
    name: 'Описание нарушения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/notRemoval': {
    name: 'Нарушение не подлежит устранению',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/correctedInEvent': {
    name: 'Нарушение устранено в ходе мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/corrected': {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/appealed': {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/plannedEliminationDates/{id}/value': {
    name: 'Плановая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/plannedMethod/{id}/title': {
    name: 'Планируемый способ устранения нарушения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/descriptions/{id}/value': {
    name: 'Пояснение инспектора к устранению нарушения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/materialType/{id}/title': {
    name: 'Сведения о факте устранения нарушения - Тип материала',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/actualMethod/title': {
    name: 'Сведения о факте устранения нарушения - Фактический способ устранения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/grade': {
    name: 'Сведения о факте устранения нарушения - Оценка исправления',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/actualEliminationDate': {
    name: 'Фактическая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  '/additionalDocuments/{id}/type/name': {
    name: 'Дополнительные документы - Тип документа',
    active: true,
  },
  '/additionalDocuments/{id}/description': {
    name: 'Дополнительные документы - Описание документа',
    active: true,
  },
  '/additionalDocuments/{id}/attachments/{id}/dateCreate': {
    name: 'Дополнительные документы - Дата и время загрузки файла',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/additionalDocuments/{id}/attachments/{id}/fileName': {
    name: 'Дополнительные документы - Файл',
    active: true,
  },
  '/organization/decisions/{id}/kind/name': {
    name: 'Вид решения',
    active: true,
  },
  '/organization/decisions/{id}/injunction/dateResolved': {
    name: 'Срок исполнения решения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/decisions/{id}/injunction/note': {
    name:
      'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
    active: true,
  },
  '/organization/decisions/{id}/date': {
    name: 'Дата решения',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/decisions/{id}/number': {
    name: 'Номер решения',
    active: true,
  },
  '/organization/decisions/{id}/noteLawsuits/{id}/value': {
    name: 'Описание решения',
    active: true,
  },
  '/organization/decisions/{id}/fioSigner': {
    name: 'Должностное лицо контрольного (надзорного) органа, подписавшее (осуществившее) решение',
    active: true,
  },
  '/organization/decisions/{id}/titleSigner/title': {
    name: 'Должность лица, подписавшего решение',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/number': {
    name: 'Номер решения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/title': {
    name: 'Наименование документа НПА',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/acceptanceDate': {
    name: 'Дата документа НПА',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/title': {
    name: 'Наименование структурной единицы',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Наименование структурной единицы',
    active: true,
  },
  '/organization/decisions/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Содержание требования',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/category/name': {
    name: 'Значимость последствий нарушения',
    active: true,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isFixed': {
    name: 'Факт устранения выявленного нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolved': {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolvedNote': {
    name: 'Сведения о факте устранения нарушения',
    active: true,
  },
  '/organization/decisions/{id}/familiarizationNotifications/{id}/knmNoticeType/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/organization/decisions/{id}/familiarizationNotifications/{id}/noticeDate': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/decisions/{id}/familiarizationNotifications/{id}/note': {
    name: 'Примечание к уведомлению',
    active: true,
  },
  '/organization/decisions/{id}/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/decisions/{id}/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/decisions/{id}/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/organization/decisions/{id}/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },

  '/inspectors/null/fullName': {
    name: 'Сведения о должностных лицах, участвующих в КНМ, СР',
    active: true,
  },
  '/isUnableToRefuse': {
    name: 'Обязательный профилактический визит',
    active: true,
    renderFunc: renderBoolean,
  },
  '/officialFullName': {
    name: 'ФИО должностного лица',
    active: true,
  },
  '/isViolations': {
    name: 'Выявленные нарушения обязательных требований',
    active: true,
    renderFunc: renderBoolean,
  },
  ...getViolationsHistoryFields(
    'organization/{id}/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}',
  ),
  ...getViolationsHistoryFields('violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}'),
  ...getViolationsHistoryFields('violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}'),
  ...getViolationsHistoryFields(
    'organization/decision/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}',
  ),

  '/changePlanReason/{id}/dateCreate': {
    name: 'Причина изменения плана - Дата последнего обновления',
    active: true,
    renderFunc: renderDate,
  },
  '/changePlanReason/{id}/reasonChangeType': {
    name: 'Причина изменения плана',
    active: true,
  },
  '/changePlanReason/{id}/requisites': {
    name: 'Причина изменения плана - Реквизиты',
    active: true,
  },
  '/changePlanReason/{id}/approve/isNeedApplyChangesInApprovedPlan': {
    name: 'Принять изменения в КНМ',
    active: true,
  },
  '/changePlanReason/{id}/approve/numberDecision': {
    name: 'Номер решения',
    active: true,
  },
  '/changePlanReason/{id}/approve/dateDecision': {
    name: 'Дата решения',
    active: true,
  },
  '/changePlanReason/{id}/approve/fioSigner': {
    name: 'Кем принято решение',
    active: true,
  },
  '/changePlanReason/{id}/approve/titleSigner': {
    name: 'Должность лица, подписавшего решение',
    active: true,
  },
  '/changePlanReason/{id}/approve/approveFile/{id}/fileName': {
    name: 'Файл решения',
    active: true,
  },
  '/warningContentCreatorPosition': {
    name: 'Должность лица, сформировавшего содержание предостережения',
    active: true,
  },
  '/organization/act/familiarizationNotifications/{id}/knmNoticeType/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/organization/act/familiarizationNotifications/{id}/noticeDate': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/act/familiarizationNotifications/{id}/note': {
    name: 'Примечание к уведомлению',
    active: true,
  },
  '/organization/act/remarks/{id}/text': {
    name: 'Текст замечания',
    active: true,
  },
  '/organization/act/remarks/{id}/signerFullName': {
    name: 'ФИО лица, оставившего замечание',
    active: true,
  },
  '/organization/act/remarks/{id}/signerPosition': {
    name: 'Должность лица, оставившего замечание',
    active: true,
  },
  '/organization/act/remarks/{id}/date': {
    name: 'Дата замечания',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/act/numberAct': {
    name: 'Номер акта КНМ, СР',
    active: true,
  },
  '/organization/act/violations/{id}/number': {
    name: 'Номер документа НПА',
    active: true,
  },
  '/organization/act/violations/{id}/title': {
    name: 'Наименование документа НПА',
    active: true,
  },
  '/organization/act/violations/{id}/acceptanceDate': {
    name: 'Дата документа НПА',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/title': {
    name: 'Наименование структурной единицы',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Содержание требования',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/category/name': {
    name: 'Значимость последствий нарушения',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/description': {
    name: 'Описание нарушения',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/notRemoval': {
    name: 'Нарушение не подлежит устранению',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/correctedInEvent': {
    name: 'Нарушение устранено в ходе мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isFixed': {
    name: 'Факт устранения выявленного нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/appealed': {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolved': {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolvedNote': {
    name: 'Сведения о факте устранения нарушения',
    active: true,
  },
  '/organization/act/isViolations': {
    name: 'Наличие выявленных нарушении',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/involvedWitnesses/{id}/fullName': {
    name: 'Привлеченные к проверке свидетели',
    active: true,
  },
  '/organization/act/organization/act/knoInspectors/{id}/fullName': {
    name: 'ФИО должностного лица контрольного (надзорного) органа, участвовавшие в КНМ, СР',
    active: true,
  },
  '/organization/act/organization/act/knoInspectors/{id}/position/title': {
    name: 'Должность лица контрольного (надзорного) органа, участвовавшие в КНМ, СР',
    active: true,
  },
  '/organization/act/creationActDateTime': {
    name: 'Дата и время составления акта КНМ, СР',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/act/signActDateTime': {
    name: 'Дата и время подписания акта КНМ, СР',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/act/document/attachments/{id}/fileName': {
    name: 'Файл акта',
    active: true,
  },
  '/organization/act/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/organization/act/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/organization/act/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/organization/act/videoFixationsCheckbox': {
    name: 'Фото (видео) фиксация потенциального нарушения ОТ',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/videoFixations/{id}/linkVideo': {
    name: 'Ссылка на видеозапись или фотоматериалы',
    active: true,
  },
  '/organization/act/videoFixations/{id}/dateVideo': {
    name: 'Дата фиксации',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/act/videoFixations/{id}/descVideo': {
    name: 'Фиксация потенциального нарушения',
    active: true,
  },
  '/organization/act/events/{id}/event/title': {
    name: 'Акт - Перечень осуществленных действий',
    active: true,
  },
  '/organization/act/events/{id}/inspectors/{id}/fullName': {
    name: 'Акт - Должностное лицо, осуществившее действие',
    active: true,
  },
  '/organization/act/events/{id}/actionNotPerformed': {
    name: 'Акт - Действие не проводилось',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/events/{id}/linkVks': {
    name: 'Акт - Действие - Ссылка на ВКС',
    active: true,
  },
  '/organization/act/events/{id}/event/linkVideo': {
    name: 'Акт - Действие - Ссылка на видеозапись',
    active: true,
  },
  '/organization/act/events/{id}/protocol/file/attachments/{id}/fileName': {
    name: 'Акт - Действие - Фаил протокола',
    active: true,
  },
  '/organization/act/events/{id}/protocol/appendicesToTheProtocolOfAction/{id}/attachments/{id}/fileName': {
    name: 'Акт - Действие - Приложения к протоколу действия - Фаил',
    active: true,
  },
  '/organization/act/events/{id}/protocol/appendicesToTheProtocolOfAction/{id}/description': {
    name: 'Акт - Действие - Приложения к протоколу действия - Описание',
    active: true,
  },
  '/organization/act/events/{id}/protocol/studiedDocuments/{id}/files/{id}/fileName': {
    name: 'Акт - Действие - Изученные документы - Фаил',
    active: true,
  },
  '/organization/act/events/{id}/protocol/studiedDocuments/{id}/description': {
    name: 'Акт - Действие - Изученные документы - Описание',
    active: true,
  },
  '/organization/act/events/{id}/uavTechnologies/{id}/typeCode': {
    name: 'Акт - Действие - Вид беспилотника',
    active: true,
  },
  '/organization/act/events/{id}/uavTechnologies/{id}/name': {
    name: 'Акт - Действие - Название беспилотника',
    active: true,
  },
  '/organization/act/events/{id}/startDate': {
    name: 'Акт - Дата начала действий',
    active: true,
    renderFunc: renderDate,
  },
  '/organization/act/events/{id}/stopDate': {
    name: 'Акт - Дата окончания действий',
    active: true,
    renderFunc: renderDate,
  },
  '/isNeedToAddAct': {
    name: 'Будет ли добавлен акт',
    active: true,
    renderFunc: renderBoolean,
  },
  '/inspectionResult/inspectionMessage': {
    name: 'Проверка за 5 дней (итог)',
    active: true,
  },
  '/inspectionResult/inspectedField': {
    name: 'Проверка за 5 дней (поле)',
    active: true,
  },
  '/inspectionResults/{id}/inspectionResult/inspectionMessage': {
    name: 'Проверка за 5 дней (итог)',
    active: true,
  },
  '/inspectionResults/{id}/inspectionResult/inspectedField': {
    name: 'Проверка за 5 дней (поле)',
    active: true,
  },
  '/massCancel/cancelled': {
    name: 'Дата и время отмены мероприятия',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/massCancel/particularCancelDecisionFile/fileName': {
    name: 'Файл решения об отмене',
    active: true,
  },
  '/massCancel/reasonFile/fileName': {
    name: 'Файл основания отмены',
    active: true,
  },
  '/massCancel/reason/name': {
    name: 'Основание отмены',
    active: true,
  },
  '/massDelete/deleted': {
    name: 'Дата и время удаления мероприятия',
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/massDelete/reason/name': {
    name: 'Основание удаления',
    active: true,
  },
  '/dataContent': {
    name:
      'Сведения о причинении вреда (ущерба) или об угрозе причинения вреда (ущерба) охраняемым законом ценностям в случаях отсутствия необходимости согласования проведения контрольного (надзорного) мероприятия с органами прокуратуры в соответствии со статьей 66 Федерального закона',
    active: true,
  },
  '/subject/act/familiarizationNotifications/{id}/knmNoticeType/name': {
    name: 'Способ уведомления',
    active: true,
  },
  '/subject/act/familiarizationNotifications/{id}/noticeDate': {
    name: 'Дата уведомления',
    active: true,
    renderFunc: renderDate,
  },
  '/subject/act/familiarizationNotifications/{id}/note': {
    name: 'Примечание к уведомлению',
    active: true,
  },
  '/subject/act/remarks/{id}/remark/text': {
    name: 'Текст замечания',
    active: true,
  },
  '/subject/act/remarks/{id}/remark/signerFullName': {
    name: 'ФИО лица, оставившего замечание',
    active: true,
  },
  '/subject/act/remarks/{id}/remark/signerPosition': {
    name: 'Должность лица, оставившего замечание',
    active: true,
  },
  '/subject/act/remarks/{id}/remark/date': {
    name: 'Дата замечания',
    active: true,
    renderFunc: renderDate,
  },
  '/subject/act/typeAct/name': {
    name: 'Вид акта',
    active: true,
  },
  '/subject/act/creationActDateTime': {
    name: 'Дата и время составления акта',
    active: true,
  },
  '/subject/act/signActDateTime': {
    name: 'Дата и время подписания акта',
    active: true,
  },
  '/subject/act/holdingDateTime': {
    name: 'Дата и время начала проведения',
    active: true,
  },
  '/subject/act/durationDays': {
    name: 'Срок проведения (в днях)',
    active: true,
  },
  '/subject/act/durationHours': {
    name: 'Срок проведения (в часах)',
    active: true,
  },
  ...getSubjectHistoryFields('/subject/act'),
  '/subject/act/knoInspectors/{id}/position/title': {
    name: 'Должностные лица контрольного (надзорного) органа, участвовавшие в контрольном (надзорном) мероприятии',
    active: true,
  },
  '/subject/act/involvedExperts/{id}/fullName': {
    name: 'Привлеченные эксперты - ФИО',
    active: true,
  },
  '/subject/act/involvedExperts/{id}/type/name': {
    name: 'Привлеченные эксперты - Должность',
    active: true,
  },
  '/subject/act/involvedWitnesses/{id}/fullName': {
    name: 'Привлеченные к проверке свидетели',
    active: true,
  },
  '/subject/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/appealed': {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  '/subject/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolved': {
    name: 'Факт устранения выявленного нарушения',
    active: true,
    renderFunc: renderBoolean,
  },
  '/subject/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/isViolationResolvedNote': {
    name: 'Сведения о факте устранения выявленного нарушения',
    active: true,
  },
  '/subject/act/events/{id}/event/startDate': {
    name: 'Дата начала действий',
    active: true,
    renderFunc: renderDate,
  },
  '/subject/act/events/{id}/event/stopDate': {
    name: 'Дата окончания действий',
    active: true,
    renderFunc: renderDate,
  },
  '/subject/act/events/{id}/event/title': {
    name: 'Перечень действий',
    active: true,
  },
  '/subject/act/fioSigner': {
    name: 'ФИО должностного лица подписавшего акт',
    active: true,
  },
  '/subject/act/titleSigner/title': {
    name: 'Должность подписавшего акт',
    active: true,
  },
  '/subject/act/events/{id}/event/protocol/appendicesToTheProtocolOfAction/{id}/description': {
    name: 'Описание приложения к протоколу действия',
    active: true,
  },
  '/subject/act/events/{id}/event/protocol/appendicesToTheProtocolOfAction/{id}/attachments/{id}/fileName': {
    name: 'Приложения к протоколу действия',
    active: true,
  },
  '/subject/act/events/{id}/event/protocol/file/attachments/{id}/fileName': {
    name: 'Файл протокола',
    active: true,
  },
  '/subject/act/events/{id}/event/inspector/{id}/fullName': {
    name: 'Должностные лица, осуществившие действие',
    active: true,
  },
  '/subject/act/events/{id}/event/uavTechnologies/{id}/typeCode': {
    name: 'Вид беспилотника',
    active: true,
  },
  '/subject/act/events/{id}/event/uavTechnologies/{id}/name': {
    name: 'Название беспилотника',
    active: true,
  },
  '/subject/act/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/subject/act/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/subject/act/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/subject/act/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/cosVersion': {
    name: 'Объект контроля - версия',
    active: true,
  },
  '/agreements/{id}/status': {
    name: 'Соглашение - Статус',
    active: true,
  },
  '/agreements/{id}/prescription': {
    name: 'Соглашение - Предписание',
    active: true,
  },
  '/agreements/{id}/violations/{id}/number': {
    name: 'Соглашение - Номер решения',
    active: true,
  },
  '/agreements/{id}/violations/{id}/title': {
    name: 'Соглашение - Наименование документа НПА',
    active: true,
  },
  '/agreements/{id}/violations/{id}/acceptanceDate': {
    name: 'Дата документа НПА',
    active: true,
  },
  '/agreements/{id}/violations/{id}/structuralUnit/title': {
    name: 'Соглашение - Наименование структурной единицы',
    active: true,
  },
  '/agreements/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Соглашение - Наименование структурной единицы',
    active: true,
  },
  '/agreements/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/title': {
    name: 'Соглашение - Содержание требования',
    active: true,
  },
  '/agreements/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/category/name': {
    name: 'Соглашение - Значимость последствий нарушения',
    active: true,
  },
  '/agreements/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/remediationPlan/plannedEliminationDates/{id}/value': {
    name: 'Соглашение - Плановая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  '/agreements/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/actualMethod/title': {
    name: 'Соглашение - Сведения о факте устранения нарушения - Фактический способ устранения',
    active: true,
  },
  '/agreements/{id}/violations/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/materialType/{id}/title': {
    name: 'Соглашение - Сведения о факте устранения нарушения - Тип материала',
    active: true,
  },
  '/agreements/{id}/violations/{id}/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/eliminationViolations/{id}/grade': {
    name: 'Соглашение - Сведения о факте устранения нарушения - Оценка исправления',
    active: true,
  },
  '/agreements/{id}/petitionOrganizationType': {
    name: 'Соглашение - Ходатайство контролируемого лица - Лицо, с которым заключается соглашение',
    active: true,
    renderFunc: renderPetitionOrganizationType,
  },
  '/agreements/{id}/petitionOrganization/subjectType': {
    name: 'Соглашение - Тип контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/inn': {
    name: 'Соглашение - ИНН контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/rafpNza': {
    name: 'Соглашение - Номер записи об аккредитации в РАФП контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/snils': {
    name: 'Соглашение - СНИЛС контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/ogrn': {
    name: 'Соглашение - ОГРН контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/kpp': {
    name: 'Соглашение - КПП контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/organizationName': {
    name: 'Соглашение - Наименование контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/locationAddress': {
    name: 'Соглашение - Адрес места нахождения контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/workAddress': {
    name: 'Соглашение - Место нахождения (осуществления деятельности) контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/factualAddress': {
    name: 'Соглашение - Место фактического осуществления деятельности контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/document': {
    name: 'Соглашение - Сведения о документе, удостоверяющем личность контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionOrganization/country': {
    name: 'Соглашение - Государство контролируемого лица',
    active: true,
  },
  '/agreements/{id}/petitionAttachment/fileName': {
    name: 'Соглашение - Файл ходатайства',
    active: true,
  },
  '/agreements/{id}/approvalOfAgreement': {
    name: 'Соглашение - Решение об утверждении ходатайства',
    active: true,
    renderFunc: renderApprovalOfAgreement,
  },
  '/agreements/{id}/approvalOfAgreementAttachment/fileName': {
    name: 'Соглашение - Файл решения',
    active: true,
  },
  '/agreements/{id}/eliminateViolationsNumber': {
    name: 'Соглашение - Номер соглашения',
    active: true,
  },
  '/agreements/{id}/eliminateViolationsAttachment/fileName': {
    name: 'Соглашение - Файл соглашения',
    active: true,
  },
  '/agreements/{id}/termOfExecutionAgreement': {
    name: 'Соглашение - Срок исполнения соглашения',
    active: true,
    renderFunc: renderDate,
  },
  '/agreements/{id}/applicationForConsiderationAttachment/fileName': {
    name: 'Соглашение - Заявление в органы прокуратуры о рассмотрении соглашения',
    active: true,
  },
  '/agreements/{id}/otherAttachments/{id}/fileName': {
    name: 'Соглашение - Иные документы',
    active: true,
  },
  '/agreements/{id}/violationCorrectionProgramAttachments/{id}/fileName': {
    name: 'Соглашение - Программа устранения нарушений',
    active: true,
  },
  '/agreements/{id}/approveInfo/prosecutorOrganization': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Наименование прокуратуры',
    active: true,
  },
  '/agreements/{id}/approveInfo/note': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Комментарий',
    active: true,
  },
  '/agreements/{id}/approveInfo/approved': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Решение по заявлению',
    active: true,
  },
  '/agreements/{id}/approveInfo/numberDecision': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Номер решения',
    active: true,
  },
  '/agreements/{id}/approveInfo/dateDecision': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Дата решения',
    active: true,
    renderFunc: renderDate,
  },
  '/agreements/{id}/approveInfo/whoMadeDecision': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Кем принято решение',
    active: true,
  },
  '/agreements/{id}/approveInfo/titleSigner': {
    name:
      'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Должность лица, подписавшего решение',
    active: true,
  },
  '/agreements/{id}/approveInfo/reasonForRefusal': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Мотивировка отказа',
    active: true,
  },
  '/agreements/{id}/approveInfo/attachment/fileName': {
    name: 'Соглашение - Сведения о согласовании соглашения с органами прокуратуры - Файл решения',
    active: true,
  },
  '/agreements/{id}/terminate/terminationReasons/{id}/name': {
    name: 'Соглашение - Основание для расторжения',
    active: true,
  },
  '/agreements/{id}/terminate/decisionTerminationAttachment/fileName': {
    name: 'Соглашение - Решение о расторжении',
    active: true,
  },
  '/agreements/{id}/terminate/whoMadeDecision': {
    name: 'Соглашение - Решение принято',
    active: true,
  },
  '/agreements/{id}/terminate/prosecutorOrganization/name': {
    name: 'Наименование органа контроля',
    active: true,
  },
  '/agreements/{id}/terminate/fioSigner': {
    name: 'ФИО принявшего решение об изменении',
    active: true,
  },
  '/agreements/{id}/terminate/titleSigner/title': {
    name: 'Должность принявшего решение об изменении',
    active: true,
  },
  '/agreements/{id}/execution/fioSigner': {
    name: 'ФИО принявшего решение',
    active: true,
  },
  '/agreements/{id}/execution/titleSigner/title': {
    name: 'Должность принявшего решение об изменении',
    active: true,
  },
  '/agreements/{id}/execution/executionDate': {
    name: 'Фактическая дата исполнения соглашения',
    active: true,
    renderFunc: renderDate,
  },
  '/agreements/{id}/execution/attachments/{id}/fileName': {
    name: 'Соглашение - Решение о расторжении',
    active: true,
  },
  '/agreements/{id}/execution/decision': {
    name: 'Решение об исполнении соглашения',
    active: true,
    renderFunc: renderAgreementExecutionDecision,
  },
  '/agreements/{id}/changes/{id}/types/{id}/type': {
    name: 'Соглашение - Вид изменения',
    active: true,
  },
  '/agreements/{id}/changes/{id}/reasons/{id}/name': {
    name: 'Соглашение - Основание для изменения',
    active: true,
  },
  '/agreements/{id}/changes/{id}/petitionAttachment/fileName': {
    name: 'Соглашение - Ходатайство об изменении соглашения',
    active: true,
  },
  '/agreements/{id}/changes/{id}/termOfExecutionAgreement': {
    name: 'Соглашение - Новый срок исполнения',
    active: true,
    renderFunc: renderDate,
  },
  '/agreements/{id}/changes/{id}/updatedAgreementAttachment/fileName': {
    name: 'Соглашение - Обновленная версия соглашения',
    active: true,
  },
  '/agreements/{id}/changes/{id}/attachment/fileName': {
    name: 'Соглашение - Решение об изменении',
    active: true,
  },
  '/agreements/{id}/changes/{id}/fioSigner': {
    name: 'Соглашение - ФИО принявшего решение об изменении',
    active: true,
  },
  '/agreements/{id}/changes/{id}/titleSigner/title': {
    name: 'Соглашение - Должность принявшего решение об изменении',
    active: true,
  },

  '/preventiveVisitSystemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/preventiveVisitSystemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/preventiveVisitSystemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/preventiveVisitSystemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },

  '/warningIssuingSystemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/warningIssuingSystemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/warningIssuingSystemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/warningIssuingSystemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/systemSignatureUsed': {
    name: systemSignatureUsedText,
    active: true,
    renderFunc: renderBoolean,
  },
  '/systemSignatureDateTime': {
    name: systemSignatureDateTimeText,
    active: true,
    renderFunc: renderDateWithTime,
  },
  '/systemSignatureMnemonic': {
    name: systemSignatureMnemonicText,
    active: true,
  },
  '/systemSignatureTitle': {
    name: systemSignatureTitleText,
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/repeatCorrected': {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/repeatCorrectedInEvent': {
    name: 'Нарушение устранено в ходе мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/repeatExplanation': {
    name: 'Пояснение',
    active: true,
  },
  '/organization/act/violations/{id}/structuralUnit/mandatoryRequirementsViolations/{id}/violations/{id}/targetErpId': {
    name: 'Ссылка на мероприятие, в ходе которого устранено нарушение',
    active: true,
  },
  '/uavTechnologies/{id}/typeCode': {
    name: 'Вид беспилотника',
    active: true,
  },
  '/uavTechnologies/{id}/name': {
    name: 'Название беспилотника',
    active: true,
  },
  '/extractPerform/attachments/{id}/fileName': {
    name: 'Файл выписки',
    active: true,
  },
  '/subject/act/document/attachments/{id}/fileName': {
    name: 'Файл акта',
    active: true,
  },
};
